{
  "schemaVersion": "0.1.0",
  "defaultVersion": "2.5.1",
  "baseUrl": "https://www.integrationsoup.com/hl7-reference",
  "articles": [
    {
      "id": "hl7-segments-guide",
      "title": "HL7 Segments Guide",
      "description": "A practical HL7 segments guide from experience, covering common patient, order, result, document, scheduling, pharmacy, billing, acknowledgment, and error segments.",
      "category": "segments",
      "route": "/segments",
      "sourcePath": "/content/articles/hl7-segments-guide.html"
    },
    {
      "id": "hl7-tables-guide",
      "title": "HL7 Tables Guide",
      "description": "A practical HL7 tables guide from experience, covering HL7-defined, user-defined, external, and local code tables, coded data types, message events, validation, and implementation best practices.",
      "category": "tables",
      "route": "/tables",
      "sourcePath": "/content/articles/hl7-tables-guide.html"
    },
    {
      "id": "hl7-datatypes-guide",
      "title": "HL7 Data Types Guide",
      "description": "A practical HL7 data types guide from experience, covering delimiters, components, repetitions, coded values, identifiers, dates, times, names, addresses, ED payloads, OBX-2, OBX-5, validation, and implementation best practices.",
      "category": "datatypes",
      "route": "/datatypes",
      "sourcePath": "/content/articles/hl7-datatypes-guide.html"
    },
    {
      "id": "hl7-messages-guide",
      "title": "HL7 Messages Guide",
      "description": "A practical HL7 messages guide from experience, covering message types, trigger events, message structures, MSH-9, ACKs, common message families, version differences, validation, and implementation best practices.",
      "category": "messages",
      "route": "/messages",
      "sourcePath": "/content/articles/hl7-messages-guide.html"
    },
    {
      "id": "hl7-segment-groups",
      "title": "HL7 Segment Groups",
      "description": "A practical guide to HL7 segment groups, explaining optional and repeating groups, why position matters, why group-aware mapping is awkward, and how HL7 Soup Web and Integration Soup help.",
      "category": "articles",
      "route": "/articles/hl7-segment-groups",
      "sourcePath": "/content/articles/hl7-segment-groups.html"
    },
    {
      "id": "scheduling-over-hl7",
      "title": "Scheduling over HL7",
      "description": "A practical guide to HL7 scheduling messages, covering SIU, SCH, AIS, AIG, AIL, AIP, appointment timing, status, services, locations, personnel, and resource handling from experience.",
      "category": "articles",
      "route": "/articles/scheduling-over-hl7",
      "sourcePath": "/content/articles/scheduling-over-hl7.html"
    },
    {
      "id": "which-hl7-version-should-i-use",
      "title": "Which HL7 version should I use?",
      "description": "A practical guide to choosing an HL7 v2 version, why the latest version is not automatically best, and how country, specialty, and implementation guides usually matter more.",
      "category": "articles",
      "route": "/articles/which-hl7-version-should-i-use",
      "sourcePath": "/content/articles/which-hl7-version-should-i-use.html"
    },
    {
      "id": "hl7-for-adt-and-patient-administration",
      "title": "HL7 for ADT and patient administration",
      "description": "A practical guide to HL7 ADT and patient administration interfaces, covering admissions, transfers, discharges, registration, updates, merges, PID, PV1, MRG, routing, and Integration Soup workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-adt-and-patient-administration",
      "sourcePath": "/content/articles/hl7-for-adt-and-patient-administration.html"
    },
    {
      "id": "hl7-for-lab-and-pathology-results",
      "title": "HL7 for lab and pathology results",
      "description": "A practical guide to HL7 lab and pathology result interfaces, covering ORU_R01, OBR, OBX, SPM, abnormal flags, status, repeating observations, and Integration Soup workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-lab-and-pathology-results",
      "sourcePath": "/content/articles/hl7-for-lab-and-pathology-results.html"
    },
    {
      "id": "hl7-for-radiology-orders-and-results",
      "title": "HL7 for radiology orders and results",
      "description": "A practical guide to HL7 radiology order and result interfaces, covering ORM, OMI, ORU, ORC, OBR, accession numbers, modality workflow, reports, and Integration Soup routing.",
      "category": "articles",
      "route": "/articles/hl7-for-radiology-orders-and-results",
      "sourcePath": "/content/articles/hl7-for-radiology-orders-and-results.html"
    },
    {
      "id": "hl7-for-immunization-vxu",
      "title": "HL7 for immunization VXU",
      "description": "A practical guide to HL7 VXU immunization interfaces, covering CDC Release 1.5, VXU_V04, RXA, RXR, OBX observations, acknowledgments, and Integration Soup validation.",
      "category": "articles",
      "route": "/articles/hl7-for-immunization-vxu",
      "sourcePath": "/content/articles/hl7-for-immunization-vxu.html"
    },
    {
      "id": "hl7-for-billing-dft",
      "title": "HL7 for billing and DFT",
      "description": "A practical guide to HL7 DFT billing interfaces, covering DFT_P03, FT1, DG1, PR1, insurance context, charge correction, and Integration Soup support workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-billing-dft",
      "sourcePath": "/content/articles/hl7-for-billing-dft.html"
    },
    {
      "id": "hl7-for-pharmacy",
      "title": "HL7 for pharmacy",
      "description": "A practical guide to HL7 pharmacy interfaces, covering RDE, RDS, RXE, RXO, RXR, ORC, medication orders, dispense workflows, safety checks, and Integration Soup routing.",
      "category": "articles",
      "route": "/articles/hl7-for-pharmacy",
      "sourcePath": "/content/articles/hl7-for-pharmacy.html"
    },
    {
      "id": "hl7-for-documents-and-pdfs",
      "title": "HL7 for documents and PDFs",
      "description": "A practical guide to HL7 document interfaces, covering MDM_T02, TXA, OBX ED values, Base64 PDFs, document identity, status, and Integration Soup workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-documents-and-pdfs",
      "sourcePath": "/content/articles/hl7-for-documents-and-pdfs.html"
    },
    {
      "id": "hl7-for-master-files-mfn",
      "title": "HL7 for master files and MFN",
      "description": "A practical guide to HL7 master file interfaces, covering MFN, MFI, MFE, MFK, provider, location, charge, test dictionaries, record-level events, and Integration Soup workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-master-files-mfn",
      "sourcePath": "/content/articles/hl7-for-master-files-mfn.html"
    },
    {
      "id": "hl7-for-interface-engine-transformations",
      "title": "HL7 for interface-engine transformations",
      "description": "A practical guide to HL7 interface-engine transformation work, covering mapping, routing, ACKs, repeats, identifiers, version differences, tests, and Integration Soup workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-interface-engine-transformations",
      "sourcePath": "/content/articles/hl7-for-interface-engine-transformations.html"
    },
    {
      "id": "hl7-for-ultrasound-orders-and-reports",
      "title": "HL7 for ultrasound orders and reports",
      "description": "A practical guide to HL7 ultrasound order and report workflows, covering radiology-style ORM/ORU, OBR, OBX, DICOM SR, measurements, narrative reports, and Integration Soup mapping.",
      "category": "articles",
      "route": "/articles/hl7-for-ultrasound-orders-and-reports",
      "sourcePath": "/content/articles/hl7-for-ultrasound-orders-and-reports.html"
    },
    {
      "id": "hl7-for-emergency-department-workflows",
      "title": "HL7 for emergency department workflows",
      "description": "A practical guide to HL7 emergency department workflows, covering ADT A04/A08/A03, PV1, DG1, OBX triage observations, syndromic reporting, and Integration Soup routing.",
      "category": "articles",
      "route": "/articles/hl7-for-emergency-department-workflows",
      "sourcePath": "/content/articles/hl7-for-emergency-department-workflows.html"
    },
    {
      "id": "hl7-for-maternity-newborn-and-mother-baby-linkage",
      "title": "HL7 for maternity, newborn, and mother/baby linkage",
      "description": "A practical guide to HL7 maternity and newborn interfaces, covering ADT, PID, NK1, PID-21, multiple births, visit linkage, baby identity, and Integration Soup workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-maternity-newborn-and-mother-baby-linkage",
      "sourcePath": "/content/articles/hl7-for-maternity-newborn-and-mother-baby-linkage.html"
    },
    {
      "id": "hl7-for-provider-identifiers-and-master-data",
      "title": "HL7 for provider identifiers and master data",
      "description": "A practical guide to HL7 provider identifiers, XCN, STF, PRA, PMU, MFN, assigning authorities, NPI-style identifiers, and Integration Soup mapping.",
      "category": "articles",
      "route": "/articles/hl7-for-provider-identifiers-and-master-data",
      "sourcePath": "/content/articles/hl7-for-provider-identifiers-and-master-data.html"
    },
    {
      "id": "hl7-for-multi-site-hospitals-and-facility-routing",
      "title": "HL7 for multi-site hospitals and facility routing",
      "description": "A practical guide to HL7 multi-site routing, covering MSH facilities, PV1 locations, assigning authorities, facility codes, ADT, orders, results, and Integration Soup operations.",
      "category": "articles",
      "route": "/articles/hl7-for-multi-site-hospitals-and-facility-routing",
      "sourcePath": "/content/articles/hl7-for-multi-site-hospitals-and-facility-routing.html"
    },
    {
      "id": "hl7-for-public-health-reporting",
      "title": "HL7 for public health reporting",
      "description": "A practical guide to HL7 public health reporting, covering ELR, syndromic surveillance, immunization, ORU, ADT, VXU, local implementation guides, and Integration Soup workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-public-health-reporting",
      "sourcePath": "/content/articles/hl7-for-public-health-reporting.html"
    },
    {
      "id": "hl7-for-imaging-result-documents-and-narrative-reports",
      "title": "HL7 for imaging result documents and narrative reports",
      "description": "A practical guide to HL7 imaging result documents, covering ORU_R01, MDM, TXA, OBX, report status, PDF/Base64 payloads, IHE Results Distribution, and Integration Soup workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-imaging-result-documents-and-narrative-reports",
      "sourcePath": "/content/articles/hl7-for-imaging-result-documents-and-narrative-reports.html"
    },
    {
      "id": "debugging-hl7-by-workflow-what-to-check-first",
      "title": "Debugging HL7 by workflow: what to check first",
      "description": "A practical debugging guide for HL7 workflows, covering ADT, orders, results, billing, documents, scheduling, ACKs, identifiers, status fields, and HL7 Soup Web.",
      "category": "articles",
      "route": "/articles/debugging-hl7-by-workflow-what-to-check-first",
      "sourcePath": "/content/articles/debugging-hl7-by-workflow-what-to-check-first.html"
    },
    {
      "id": "hl7-for-cancer-registry-and-pathology-reporting",
      "title": "HL7 for cancer registry and pathology reporting",
      "description": "A carefully scoped guide to HL7 cancer registry and pathology reporting, covering ORU_R01, OBR, OBX, SPM, NAACCR guidance, synoptic reports, and Integration Soup validation workflows.",
      "category": "articles",
      "route": "/articles/hl7-for-cancer-registry-and-pathology-reporting",
      "sourcePath": "/content/articles/hl7-for-cancer-registry-and-pathology-reporting.html"
    },
    {
      "id": "segment-abs",
      "title": "HL7 ABS (Abstract)",
      "description": "Practical notes on HL7 ABS Abstract, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/abs",
      "sourcePath": "/content/articles/segments/abs.html",
      "segmentCode": "ABS"
    },
    {
      "id": "segment-acc",
      "title": "HL7 ACC (Accident)",
      "description": "Practical notes on HL7 ACC Accident, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/acc",
      "sourcePath": "/content/articles/segments/acc.html",
      "segmentCode": "ACC"
    },
    {
      "id": "segment-add",
      "title": "HL7 ADD (Addendum)",
      "description": "Practical notes on HL7 ADD Addendum, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/add",
      "sourcePath": "/content/articles/segments/add.html",
      "segmentCode": "ADD",
      "fieldsPanelDefaultOpen": true
    },
    {
      "id": "segment-aff",
      "title": "HL7 AFF (Professional Affiliation)",
      "description": "Practical notes on HL7 AFF Professional Affiliation, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/aff",
      "sourcePath": "/content/articles/segments/aff.html",
      "segmentCode": "AFF"
    },
    {
      "id": "segment-aig",
      "title": "HL7 AIG (Appointment Information - General Resource)",
      "description": "Practical notes on HL7 AIG Appointment Information - General Resource, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/aig",
      "sourcePath": "/content/articles/segments/aig.html",
      "segmentCode": "AIG"
    },
    {
      "id": "segment-ail",
      "title": "HL7 AIL (Appointment Information - Location Resource)",
      "description": "Practical notes on HL7 AIL Appointment Information - Location Resource, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/ail",
      "sourcePath": "/content/articles/segments/ail.html",
      "segmentCode": "AIL"
    },
    {
      "id": "segment-aip",
      "title": "HL7 AIP (Appointment Information - Personnel Resource)",
      "description": "Practical notes on HL7 AIP Appointment Information - Personnel Resource, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/aip",
      "sourcePath": "/content/articles/segments/aip.html",
      "segmentCode": "AIP"
    },
    {
      "id": "segment-ais",
      "title": "HL7 AIS (Appointment Information)",
      "description": "Practical notes on HL7 AIS Appointment Information, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/ais",
      "sourcePath": "/content/articles/segments/ais.html",
      "segmentCode": "AIS"
    },
    {
      "id": "segment-al1",
      "title": "HL7 AL1 (Patient Allergy Information)",
      "description": "The AL1 segment of an HL7 message carries patient allergy and adverse reaction information. Here I examine each AL1 field and how it is commonly used in real integrations.",
      "category": "segments",
      "route": "/segments/al1",
      "sourcePath": "/content/articles/segments/al1.html",
      "segmentCode": "AL1"
    },
    {
      "id": "segment-apr",
      "title": "HL7 APR (Appointment Preferences)",
      "description": "Practical notes on HL7 APR Appointment Preferences, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/apr",
      "sourcePath": "/content/articles/segments/apr.html",
      "segmentCode": "APR"
    },
    {
      "id": "segment-arq",
      "title": "HL7 ARQ (Appointment Request)",
      "description": "Practical notes on HL7 ARQ Appointment Request, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/arq",
      "sourcePath": "/content/articles/segments/arq.html",
      "segmentCode": "ARQ"
    },
    {
      "id": "segment-aut",
      "title": "HL7 AUT (Authorization Information)",
      "description": "Practical notes on HL7 AUT Authorization Information, including field guidance, datatype links, and implementation cautions.",
      "category": "segments",
      "route": "/segments/aut",
      "sourcePath": "/content/articles/segments/aut.html",
      "segmentCode": "AUT"
    },
    {
      "id": "segment-bhs",
      "title": "HL7 BHS (Batch Header)",
      "description": "Practical guidance for HL7 BHS Batch Header, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/bhs",
      "sourcePath": "/content/articles/segments/bhs.html",
      "segmentCode": "BHS"
    },
    {
      "id": "segment-blc",
      "title": "HL7 BLC (Blood Code)",
      "description": "Practical guidance for HL7 BLC Blood Code, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/blc",
      "sourcePath": "/content/articles/segments/blc.html",
      "segmentCode": "BLC"
    },
    {
      "id": "segment-blg",
      "title": "HL7 BLG (Billing)",
      "description": "Practical guidance for HL7 BLG Billing, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/blg",
      "sourcePath": "/content/articles/segments/blg.html",
      "segmentCode": "BLG"
    },
    {
      "id": "segment-bpo",
      "title": "HL7 BPO (Blood product order)",
      "description": "Practical guidance for HL7 BPO Blood product order, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/bpo",
      "sourcePath": "/content/articles/segments/bpo.html",
      "segmentCode": "BPO"
    },
    {
      "id": "segment-bpx",
      "title": "HL7 BPX (Blood product dispense status)",
      "description": "Practical guidance for HL7 BPX Blood product dispense status, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/bpx",
      "sourcePath": "/content/articles/segments/bpx.html",
      "segmentCode": "BPX"
    },
    {
      "id": "segment-bts",
      "title": "HL7 BTS (Batch Trailer)",
      "description": "Practical guidance for HL7 BTS Batch Trailer, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/bts",
      "sourcePath": "/content/articles/segments/bts.html",
      "segmentCode": "BTS"
    },
    {
      "id": "segment-btx",
      "title": "HL7 BTX (Blood Product Transfusion/Disposition)",
      "description": "Practical guidance for HL7 BTX Blood Product Transfusion/Disposition, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/btx",
      "sourcePath": "/content/articles/segments/btx.html",
      "segmentCode": "BTX"
    },
    {
      "id": "segment-cdm",
      "title": "HL7 CDM (Charge Description Master)",
      "description": "Practical guidance for HL7 CDM Charge Description Master, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/cdm",
      "sourcePath": "/content/articles/segments/cdm.html",
      "segmentCode": "CDM"
    },
    {
      "id": "segment-cer",
      "title": "HL7 CER (Certificate Detail)",
      "description": "Practical guidance for HL7 CER Certificate Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/cer",
      "sourcePath": "/content/articles/segments/cer.html",
      "segmentCode": "CER"
    },
    {
      "id": "segment-cm0",
      "title": "HL7 CM0 (Clinical Study Master)",
      "description": "Practical guidance for HL7 CM0 Clinical Study Master, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/cm0",
      "sourcePath": "/content/articles/segments/cm0.html",
      "segmentCode": "CM0"
    },
    {
      "id": "segment-cm1",
      "title": "HL7 CM1 (Clinical Study Phase Master)",
      "description": "Practical guidance for HL7 CM1 Clinical Study Phase Master, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/cm1",
      "sourcePath": "/content/articles/segments/cm1.html",
      "segmentCode": "CM1"
    },
    {
      "id": "segment-cm2",
      "title": "HL7 CM2 (Clinical Study Schedule Master)",
      "description": "Practical guidance for HL7 CM2 Clinical Study Schedule Master, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/cm2",
      "sourcePath": "/content/articles/segments/cm2.html",
      "segmentCode": "CM2"
    },
    {
      "id": "segment-cns",
      "title": "HL7 CNS (Clear Notification)",
      "description": "Practical guidance for HL7 CNS Clear Notification, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/cns",
      "sourcePath": "/content/articles/segments/cns.html",
      "segmentCode": "CNS"
    },
    {
      "id": "segment-con-segment",
      "title": "HL7 CON (Consent Segment)",
      "description": "Practical guidance for HL7 CON Consent Segment, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/con-segment",
      "sourcePath": "/content/articles/segments/con-segment.html",
      "segmentCode": "CON"
    },
    {
      "id": "segment-csp",
      "title": "HL7 CSP (Clinical Study Phase)",
      "description": "Practical guidance for HL7 CSP Clinical Study Phase, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/csp",
      "sourcePath": "/content/articles/segments/csp.html",
      "segmentCode": "CSP"
    },
    {
      "id": "segment-csr",
      "title": "HL7 CSR (Clinical Study Registration)",
      "description": "Practical guidance for HL7 CSR Clinical Study Registration, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/csr",
      "sourcePath": "/content/articles/segments/csr.html",
      "segmentCode": "CSR"
    },
    {
      "id": "segment-css",
      "title": "HL7 CSS (Clinical Study Data Schedule Segment)",
      "description": "Practical guidance for HL7 CSS Clinical Study Data Schedule Segment, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/css",
      "sourcePath": "/content/articles/segments/css.html",
      "segmentCode": "CSS"
    },
    {
      "id": "segment-ctd",
      "title": "HL7 CTD (Contact Data)",
      "description": "Practical guidance for HL7 CTD Contact Data, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ctd",
      "sourcePath": "/content/articles/segments/ctd.html",
      "segmentCode": "CTD"
    },
    {
      "id": "segment-cti",
      "title": "HL7 CTI (Clinical Trial Identification)",
      "description": "Practical guidance for HL7 CTI Clinical Trial Identification, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/cti",
      "sourcePath": "/content/articles/segments/cti.html",
      "segmentCode": "CTI"
    },
    {
      "id": "segment-db1",
      "title": "HL7 DB1 (Disability)",
      "description": "Practical guidance for HL7 DB1 Disability, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/db1",
      "sourcePath": "/content/articles/segments/db1.html",
      "segmentCode": "DB1"
    },
    {
      "id": "segment-dg1",
      "title": "HL7 DG1 (Diagnosis)",
      "description": "The DG1 segment of an HL7 message carries coded diagnosis information, including admitting, working, final, billing, order, priority, clinician, and update details.",
      "category": "segments",
      "route": "/segments/dg1",
      "sourcePath": "/content/articles/segments/dg1.html",
      "segmentCode": "DG1"
    },
    {
      "id": "segment-drg",
      "title": "HL7 DRG (Diagnosis Related Group)",
      "description": "Practical guidance for HL7 DRG Diagnosis Related Group, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/drg",
      "sourcePath": "/content/articles/segments/drg.html",
      "segmentCode": "DRG"
    },
    {
      "id": "segment-dsc",
      "title": "HL7 DSC (Continuation Pointer)",
      "description": "Practical guidance for HL7 DSC Continuation Pointer, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/dsc",
      "sourcePath": "/content/articles/segments/dsc.html",
      "segmentCode": "DSC"
    },
    {
      "id": "segment-dsp",
      "title": "HL7 DSP (Display Data)",
      "description": "Practical guidance for HL7 DSP Display Data, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/dsp",
      "sourcePath": "/content/articles/segments/dsp.html",
      "segmentCode": "DSP"
    },
    {
      "id": "segment-ecd",
      "title": "HL7 ECD (Equipment Command)",
      "description": "Practical guidance for HL7 ECD Equipment Command, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ecd",
      "sourcePath": "/content/articles/segments/ecd.html",
      "segmentCode": "ECD"
    },
    {
      "id": "segment-ecr",
      "title": "HL7 ECR (Equipment Command Response)",
      "description": "Practical guidance for HL7 ECR Equipment Command Response, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ecr",
      "sourcePath": "/content/articles/segments/ecr.html",
      "segmentCode": "ECR"
    },
    {
      "id": "segment-edu",
      "title": "HL7 EDU (Educational Detail)",
      "description": "Practical guidance for HL7 EDU Educational Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/edu",
      "sourcePath": "/content/articles/segments/edu.html",
      "segmentCode": "EDU"
    },
    {
      "id": "segment-eql",
      "title": "HL7 EQL (EQL)",
      "description": "Practical guidance for HL7 EQL EQL, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/eql",
      "sourcePath": "/content/articles/segments/eql.html",
      "segmentCode": "EQL"
    },
    {
      "id": "segment-eqp",
      "title": "HL7 EQP (Equipment/log Service)",
      "description": "Practical guidance for HL7 EQP Equipment/log Service, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/eqp",
      "sourcePath": "/content/articles/segments/eqp.html",
      "segmentCode": "EQP"
    },
    {
      "id": "segment-equ",
      "title": "HL7 EQU (Equipment Detail)",
      "description": "Practical guidance for HL7 EQU Equipment Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/equ",
      "sourcePath": "/content/articles/segments/equ.html",
      "segmentCode": "EQU"
    },
    {
      "id": "segment-erq",
      "title": "HL7 ERQ (ERQ)",
      "description": "Practical guidance for HL7 ERQ ERQ, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/erq",
      "sourcePath": "/content/articles/segments/erq.html",
      "segmentCode": "ERQ"
    },
    {
      "id": "segment-err",
      "title": "HL7 ERR (Error)",
      "description": "Practical guidance for HL7 ERR Error, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/err",
      "sourcePath": "/content/articles/segments/err.html",
      "segmentCode": "ERR"
    },
    {
      "id": "segment-evn",
      "title": "HL7 EVN (Event Type)",
      "description": "The EVN segment of an HL7 message carries trigger event timing, reason, operator, and event facility information, especially in ADT-style messages.",
      "category": "segments",
      "route": "/segments/evn",
      "sourcePath": "/content/articles/segments/evn.html",
      "segmentCode": "EVN"
    },
    {
      "id": "segment-fac",
      "title": "HL7 FAC (Facility)",
      "description": "Practical guidance for HL7 FAC Facility, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/fac",
      "sourcePath": "/content/articles/segments/fac.html",
      "segmentCode": "FAC"
    },
    {
      "id": "segment-fhs",
      "title": "HL7 FHS (File Header)",
      "description": "Practical guidance for HL7 FHS File Header, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/fhs",
      "sourcePath": "/content/articles/segments/fhs.html",
      "segmentCode": "FHS"
    },
    {
      "id": "segment-ft1",
      "title": "HL7 FT1 (Financial Transaction)",
      "description": "The FT1 segment of an HL7 message carries financial transaction detail for charges, payments, adjustments, and patient accounting. Here I examine each FT1 field and how it is commonly used in real integrations.",
      "category": "segments",
      "route": "/segments/ft1",
      "sourcePath": "/content/articles/segments/ft1.html",
      "segmentCode": "FT1"
    },
    {
      "id": "segment-fts",
      "title": "HL7 FTS (File Trailer)",
      "description": "Practical guidance for HL7 FTS File Trailer, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/fts",
      "sourcePath": "/content/articles/segments/fts.html",
      "segmentCode": "FTS"
    },
    {
      "id": "segment-gol",
      "title": "HL7 GOL (Goal Detail)",
      "description": "Practical guidance for HL7 GOL Goal Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/gol",
      "sourcePath": "/content/articles/segments/gol.html",
      "segmentCode": "GOL"
    },
    {
      "id": "segment-gp1",
      "title": "HL7 GP1 (Grouping/Reimbursement - Visit)",
      "description": "Practical guidance for HL7 GP1 Grouping/Reimbursement - Visit, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/gp1",
      "sourcePath": "/content/articles/segments/gp1.html",
      "segmentCode": "GP1"
    },
    {
      "id": "segment-gp2",
      "title": "HL7 GP2 (Grouping/Reimbursement - Procedure Line Item)",
      "description": "Practical guidance for HL7 GP2 Grouping/Reimbursement - Procedure Line Item, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/gp2",
      "sourcePath": "/content/articles/segments/gp2.html",
      "segmentCode": "GP2"
    },
    {
      "id": "segment-gt1",
      "title": "HL7 GT1 (Guarantor)",
      "description": "The GT1 segment of an HL7 message carries guarantor, billing responsibility, relationship, employer, organisation, billing hold, contact, and financial class details.",
      "category": "segments",
      "route": "/segments/gt1",
      "sourcePath": "/content/articles/segments/gt1.html",
      "segmentCode": "GT1"
    },
    {
      "id": "segment-iam",
      "title": "HL7 IAM (Patient Adverse Reaction Information)",
      "description": "The IAM segment of an HL7 message carries patient allergy and adverse reaction information with action codes and unique identifiers. Here I examine each IAM field and contrast IAM with AL1.",
      "category": "segments",
      "route": "/segments/iam",
      "sourcePath": "/content/articles/segments/iam.html",
      "segmentCode": "IAM"
    },
    {
      "id": "segment-iim",
      "title": "HL7 IIM (Inventory Item Master)",
      "description": "Practical guidance for HL7 IIM Inventory Item Master, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/iim",
      "sourcePath": "/content/articles/segments/iim.html",
      "segmentCode": "IIM"
    },
    {
      "id": "segment-in1",
      "title": "HL7 IN1 (Insurance)",
      "description": "The IN1 segment of an HL7 message carries insurance coverage, payer, plan, group, subscriber, policy, verification, coordination of benefits, and billing details.",
      "category": "segments",
      "route": "/segments/in1",
      "sourcePath": "/content/articles/segments/in1.html",
      "segmentCode": "IN1"
    },
    {
      "id": "segment-in2",
      "title": "HL7 IN2 (Insurance Additional Information)",
      "description": "The IN2 segment of an HL7 message carries additional insurance, subscriber, employer, Medicare, Medicaid, military, eligibility, policy, and billing detail. Here I examine each IN2 field and how it is commonly used in real integrations.",
      "category": "segments",
      "route": "/segments/in2",
      "sourcePath": "/content/articles/segments/in2.html",
      "segmentCode": "IN2"
    },
    {
      "id": "segment-in3",
      "title": "HL7 IN3 (Insurance Additional Information, Certification)",
      "description": "Practical guidance for HL7 IN3 Insurance Additional Information, Certification, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/in3",
      "sourcePath": "/content/articles/segments/in3.html",
      "segmentCode": "IN3"
    },
    {
      "id": "segment-inv",
      "title": "HL7 INV (Inventory Detail)",
      "description": "Practical guidance for HL7 INV Inventory Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/inv",
      "sourcePath": "/content/articles/segments/inv.html",
      "segmentCode": "INV"
    },
    {
      "id": "segment-ipc",
      "title": "HL7 IPC (Imaging Procedure Control Segment)",
      "description": "Practical guidance for HL7 IPC Imaging Procedure Control Segment, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ipc",
      "sourcePath": "/content/articles/segments/ipc.html",
      "segmentCode": "IPC"
    },
    {
      "id": "segment-isd",
      "title": "HL7 ISD (Interaction Status Detail)",
      "description": "Practical guidance for HL7 ISD Interaction Status Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/isd",
      "sourcePath": "/content/articles/segments/isd.html",
      "segmentCode": "ISD"
    },
    {
      "id": "segment-lan",
      "title": "HL7 LAN (Language Detail)",
      "description": "Practical guidance for HL7 LAN Language Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/lan",
      "sourcePath": "/content/articles/segments/lan.html",
      "segmentCode": "LAN"
    },
    {
      "id": "segment-lcc",
      "title": "HL7 LCC (Location Charge Code)",
      "description": "Practical guidance for HL7 LCC Location Charge Code, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/lcc",
      "sourcePath": "/content/articles/segments/lcc.html",
      "segmentCode": "LCC"
    },
    {
      "id": "segment-lch",
      "title": "HL7 LCH (Location Characteristic)",
      "description": "Practical guidance for HL7 LCH Location Characteristic, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/lch",
      "sourcePath": "/content/articles/segments/lch.html",
      "segmentCode": "LCH"
    },
    {
      "id": "segment-ldp",
      "title": "HL7 LDP (Location Department)",
      "description": "Practical guidance for HL7 LDP Location Department, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ldp",
      "sourcePath": "/content/articles/segments/ldp.html",
      "segmentCode": "LDP"
    },
    {
      "id": "segment-loc",
      "title": "HL7 LOC (Location Identification)",
      "description": "Practical guidance for HL7 LOC Location Identification, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/loc",
      "sourcePath": "/content/articles/segments/loc.html",
      "segmentCode": "LOC"
    },
    {
      "id": "segment-lrl",
      "title": "HL7 LRL (Location Relationship)",
      "description": "Practical guidance for HL7 LRL Location Relationship, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/lrl",
      "sourcePath": "/content/articles/segments/lrl.html",
      "segmentCode": "LRL"
    },
    {
      "id": "segment-mfa",
      "title": "HL7 MFA (Master File Acknowledgment)",
      "description": "Practical guidance for HL7 MFA Master File Acknowledgment, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/mfa",
      "sourcePath": "/content/articles/segments/mfa.html",
      "segmentCode": "MFA"
    },
    {
      "id": "segment-mfe",
      "title": "HL7 MFE (Master File Entry)",
      "description": "Practical guidance for HL7 MFE Master File Entry, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/mfe",
      "sourcePath": "/content/articles/segments/mfe.html",
      "segmentCode": "MFE"
    },
    {
      "id": "segment-mfi",
      "title": "HL7 MFI (Master File Identification)",
      "description": "Practical guidance for HL7 MFI Master File Identification, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/mfi",
      "sourcePath": "/content/articles/segments/mfi.html",
      "segmentCode": "MFI"
    },
    {
      "id": "segment-mrg",
      "title": "HL7 MRG (Merge Patient Information)",
      "description": "Practical guidance for HL7 MRG Merge Patient Information, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/mrg",
      "sourcePath": "/content/articles/segments/mrg.html",
      "segmentCode": "MRG"
    },
    {
      "id": "segment-msa",
      "title": "HL7 MSA (Message Acknowledgment)",
      "description": "The MSA segment of an HL7 ACK message tells the sender whether the original message was accepted, errored, or rejected, and links the response back to the original message control ID.",
      "category": "segments",
      "route": "/segments/msa",
      "sourcePath": "/content/articles/segments/msa.html",
      "segmentCode": "MSA"
    },
    {
      "id": "segment-msh",
      "title": "HL7 MSH (Message Header)",
      "description": "The HL7 MSH segment starts every HL7 v2 message and carries routing, message type, control ID, processing, version, acknowledgment, character set, and profile details.",
      "category": "segments",
      "route": "/segments/msh",
      "sourcePath": "/content/articles/segments/msh.html",
      "segmentCode": "MSH"
    },
    {
      "id": "segment-nck",
      "title": "HL7 NCK (System Clock)",
      "description": "Practical guidance for HL7 NCK System Clock, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/nck",
      "sourcePath": "/content/articles/segments/nck.html",
      "segmentCode": "NCK"
    },
    {
      "id": "segment-nds",
      "title": "HL7 NDS (Notification Detail)",
      "description": "Practical guidance for HL7 NDS Notification Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/nds",
      "sourcePath": "/content/articles/segments/nds.html",
      "segmentCode": "NDS"
    },
    {
      "id": "segment-nk1",
      "title": "HL7 NK1 (Next of Kin)",
      "description": "The NK1 segment of an HL7 message carries next of kin, emergency contact, guardian, employer, agency, and other associated-party details for a patient.",
      "category": "segments",
      "route": "/segments/nk1",
      "sourcePath": "/content/articles/segments/nk1.html",
      "segmentCode": "NK1"
    },
    {
      "id": "segment-npu",
      "title": "HL7 NPU (Bed Status Update)",
      "description": "Practical guidance for HL7 NPU Bed Status Update, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/npu",
      "sourcePath": "/content/articles/segments/npu.html",
      "segmentCode": "NPU"
    },
    {
      "id": "segment-nsc",
      "title": "HL7 NSC (Application Status Change)",
      "description": "Practical guidance for HL7 NSC Application Status Change, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/nsc",
      "sourcePath": "/content/articles/segments/nsc.html",
      "segmentCode": "NSC"
    },
    {
      "id": "segment-nst",
      "title": "HL7 NST (Application control level statistics)",
      "description": "Practical guidance for HL7 NST Application control level statistics, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/nst",
      "sourcePath": "/content/articles/segments/nst.html",
      "segmentCode": "NST"
    },
    {
      "id": "segment-nte",
      "title": "HL7 NTE (Notes and Comments)",
      "description": "The NTE segment of an HL7 message carries notes and comments attached to nearby segments such as PID, ORC, OBR, OBX, and SCH.",
      "category": "segments",
      "route": "/segments/nte",
      "sourcePath": "/content/articles/segments/nte.html",
      "segmentCode": "NTE"
    },
    {
      "id": "segment-obr",
      "title": "HL7 OBR (Observation Request)",
      "description": "The OBR segment of an HL7 message describes an observation request, diagnostic study, test panel, specimen context, service identifier, result status, and the result header for following OBX segments.",
      "category": "segments",
      "route": "/segments/obr",
      "sourcePath": "/content/articles/segments/obr.html",
      "segmentCode": "OBR"
    },
    {
      "id": "segment-obx",
      "title": "HL7 OBX (Observation/Result)",
      "description": "The OBX segment of an HL7 message carries individual observation values, including numeric lab results, coded answers, narrative reports, microbiology findings, embedded documents, and device observations.",
      "category": "segments",
      "route": "/segments/obx",
      "sourcePath": "/content/articles/segments/obx.html",
      "segmentCode": "OBX"
    },
    {
      "id": "segment-ods",
      "title": "HL7 ODS (Dietary Orders, Supplements, and Preferences)",
      "description": "Practical guidance for HL7 ODS Dietary Orders, Supplements, and Preferences, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ods",
      "sourcePath": "/content/articles/segments/ods.html",
      "segmentCode": "ODS"
    },
    {
      "id": "segment-odt",
      "title": "HL7 ODT (Diet Tray Instructions)",
      "description": "Practical guidance for HL7 ODT Diet Tray Instructions, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/odt",
      "sourcePath": "/content/articles/segments/odt.html",
      "segmentCode": "ODT"
    },
    {
      "id": "segment-om1",
      "title": "HL7 OM1 (General Segment)",
      "description": "Practical guidance for HL7 OM1 General Segment, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/om1",
      "sourcePath": "/content/articles/segments/om1.html",
      "segmentCode": "OM1"
    },
    {
      "id": "segment-om2",
      "title": "HL7 OM2 (Numeric Observation)",
      "description": "Practical guidance for HL7 OM2 Numeric Observation, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/om2",
      "sourcePath": "/content/articles/segments/om2.html",
      "segmentCode": "OM2"
    },
    {
      "id": "segment-om3",
      "title": "HL7 OM3 (Categorical Service/Test/Observation)",
      "description": "Practical guidance for HL7 OM3 Categorical Service/Test/Observation, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/om3",
      "sourcePath": "/content/articles/segments/om3.html",
      "segmentCode": "OM3"
    },
    {
      "id": "segment-om4",
      "title": "HL7 OM4 (Observations that Require Specimens)",
      "description": "Practical guidance for HL7 OM4 Observations that Require Specimens, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/om4",
      "sourcePath": "/content/articles/segments/om4.html",
      "segmentCode": "OM4"
    },
    {
      "id": "segment-om5",
      "title": "HL7 OM5 (Observation Batteries (Sets))",
      "description": "Practical guidance for HL7 OM5 Observation Batteries (Sets), including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/om5",
      "sourcePath": "/content/articles/segments/om5.html",
      "segmentCode": "OM5"
    },
    {
      "id": "segment-om6",
      "title": "HL7 OM6 (Observations that are Calculated from Other Observations)",
      "description": "Practical guidance for HL7 OM6 Observations that are Calculated from Other Observations, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/om6",
      "sourcePath": "/content/articles/segments/om6.html",
      "segmentCode": "OM6"
    },
    {
      "id": "segment-om7",
      "title": "HL7 OM7 (Additional Basic Attributes)",
      "description": "Practical guidance for HL7 OM7 Additional Basic Attributes, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/om7",
      "sourcePath": "/content/articles/segments/om7.html",
      "segmentCode": "OM7"
    },
    {
      "id": "segment-orc",
      "title": "HL7 ORC (Common Order)",
      "description": "The ORC segment of an HL7 message carries order control information, including order lifecycle actions, placer and filler order numbers, status, timing, providers, and ordering organisation details.",
      "category": "segments",
      "route": "/segments/orc",
      "sourcePath": "/content/articles/segments/orc.html",
      "segmentCode": "ORC"
    },
    {
      "id": "segment-org",
      "title": "HL7 ORG (Practitioner Organization Unit)",
      "description": "Practical guidance for HL7 ORG Practitioner Organization Unit, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/org",
      "sourcePath": "/content/articles/segments/org.html",
      "segmentCode": "ORG"
    },
    {
      "id": "segment-ovr",
      "title": "HL7 OVR (Override Segment)",
      "description": "Practical guidance for HL7 OVR Override Segment, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ovr",
      "sourcePath": "/content/articles/segments/ovr.html",
      "segmentCode": "OVR"
    },
    {
      "id": "segment-pcr",
      "title": "HL7 PCR (Possible Causal Relationship)",
      "description": "Practical guidance for HL7 PCR Possible Causal Relationship, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/pcr",
      "sourcePath": "/content/articles/segments/pcr.html",
      "segmentCode": "PCR"
    },
    {
      "id": "segment-pd1",
      "title": "HL7 PD1 (Patient Additional Demographic)",
      "description": "The PD1 segment of an HL7 message carries additional patient demographic, privacy, publicity, registry, provider, and advance directive information. Here I examine each PD1 field and how it is commonly used in real integrations.",
      "category": "segments",
      "route": "/segments/pd1",
      "sourcePath": "/content/articles/segments/pd1.html",
      "segmentCode": "PD1"
    },
    {
      "id": "segment-pda",
      "title": "HL7 PDA (Patient Death and Autopsy)",
      "description": "Practical guidance for HL7 PDA Patient Death and Autopsy, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/pda",
      "sourcePath": "/content/articles/segments/pda.html",
      "segmentCode": "PDA"
    },
    {
      "id": "segment-pdc",
      "title": "HL7 PDC (Product Detail Country)",
      "description": "Practical guidance for HL7 PDC Product Detail Country, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/pdc",
      "sourcePath": "/content/articles/segments/pdc.html",
      "segmentCode": "PDC"
    },
    {
      "id": "segment-peo",
      "title": "HL7 PEO (Product Experience Observation)",
      "description": "Practical guidance for HL7 PEO Product Experience Observation, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/peo",
      "sourcePath": "/content/articles/segments/peo.html",
      "segmentCode": "PEO"
    },
    {
      "id": "segment-pes",
      "title": "HL7 PES (Product Experience Sender)",
      "description": "Practical guidance for HL7 PES Product Experience Sender, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/pes",
      "sourcePath": "/content/articles/segments/pes.html",
      "segmentCode": "PES"
    },
    {
      "id": "segment-pid",
      "title": "HL7 PID (Patient Identification)",
      "description": "The PID segment of an HL7 message identifies the patient and carries their core demographics. Here I examine each PID field and how it is commonly used in real integrations.",
      "category": "segments",
      "route": "/segments/pid",
      "sourcePath": "/content/articles/segments/pid.html",
      "segmentCode": "PID"
    },
    {
      "id": "segment-pr1",
      "title": "HL7 PR1 (Procedures)",
      "description": "Practical guidance for HL7 PR1 Procedures, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/pr1",
      "sourcePath": "/content/articles/segments/pr1.html",
      "segmentCode": "PR1"
    },
    {
      "id": "segment-pra",
      "title": "HL7 PRA (Practitioner Detail)",
      "description": "Practical guidance for HL7 PRA Practitioner Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/pra",
      "sourcePath": "/content/articles/segments/pra.html",
      "segmentCode": "PRA"
    },
    {
      "id": "segment-prb",
      "title": "HL7 PRB (Problem Details)",
      "description": "Practical guidance for HL7 PRB Problem Details, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/prb",
      "sourcePath": "/content/articles/segments/prb.html",
      "segmentCode": "PRB"
    },
    {
      "id": "segment-prc",
      "title": "HL7 PRC (Pricing)",
      "description": "Practical guidance for HL7 PRC Pricing, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/prc",
      "sourcePath": "/content/articles/segments/prc.html",
      "segmentCode": "PRC"
    },
    {
      "id": "segment-prd",
      "title": "HL7 PRD (Provider Data)",
      "description": "Practical guidance for HL7 PRD Provider Data, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/prd",
      "sourcePath": "/content/articles/segments/prd.html",
      "segmentCode": "PRD"
    },
    {
      "id": "segment-psh",
      "title": "HL7 PSH (Product Summary Header)",
      "description": "Practical guidance for HL7 PSH Product Summary Header, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/psh",
      "sourcePath": "/content/articles/segments/psh.html",
      "segmentCode": "PSH"
    },
    {
      "id": "segment-pth",
      "title": "HL7 PTH (Pathway)",
      "description": "Practical guidance for HL7 PTH Pathway, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/pth",
      "sourcePath": "/content/articles/segments/pth.html",
      "segmentCode": "PTH"
    },
    {
      "id": "segment-pv1",
      "title": "HL7 PV1 (Patient Visit)",
      "description": "The PV1 segment of an HL7 message describes the patient visit or account, including patient class, location, providers, visit number, admit and discharge details, and financial context.",
      "category": "segments",
      "route": "/segments/pv1",
      "sourcePath": "/content/articles/segments/pv1.html",
      "segmentCode": "PV1"
    },
    {
      "id": "segment-pv2",
      "title": "HL7 PV2 (Patient Visit - Additional Information)",
      "description": "Practical guidance for HL7 PV2 Patient Visit - Additional Information, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/pv2",
      "sourcePath": "/content/articles/segments/pv2.html",
      "segmentCode": "PV2"
    },
    {
      "id": "segment-qak",
      "title": "HL7 QAK (Query Acknowledgment)",
      "description": "Practical guidance for HL7 QAK Query Acknowledgment, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/qak",
      "sourcePath": "/content/articles/segments/qak.html",
      "segmentCode": "QAK"
    },
    {
      "id": "segment-qid",
      "title": "HL7 QID (Query Identification)",
      "description": "Practical guidance for HL7 QID Query Identification, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/qid",
      "sourcePath": "/content/articles/segments/qid.html",
      "segmentCode": "QID"
    },
    {
      "id": "segment-qpd",
      "title": "HL7 QPD (Query Parameter Definition)",
      "description": "Practical guidance for HL7 QPD Query Parameter Definition, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/qpd",
      "sourcePath": "/content/articles/segments/qpd.html",
      "segmentCode": "QPD"
    },
    {
      "id": "segment-qrd",
      "title": "HL7 QRD (Original-Style Query Definition)",
      "description": "Practical guidance for HL7 QRD Original-Style Query Definition, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/qrd",
      "sourcePath": "/content/articles/segments/qrd.html",
      "segmentCode": "QRD"
    },
    {
      "id": "segment-qrf",
      "title": "HL7 QRF (Original style query filter)",
      "description": "Practical guidance for HL7 QRF Original style query filter, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/qrf",
      "sourcePath": "/content/articles/segments/qrf.html",
      "segmentCode": "QRF"
    },
    {
      "id": "segment-qri",
      "title": "HL7 QRI (Query Response Instance)",
      "description": "Practical guidance for HL7 QRI Query Response Instance, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/qri",
      "sourcePath": "/content/articles/segments/qri.html",
      "segmentCode": "QRI"
    },
    {
      "id": "segment-rcp",
      "title": "HL7 RCP (Response Control Parameter)",
      "description": "Practical guidance for HL7 RCP Response Control Parameter, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rcp",
      "sourcePath": "/content/articles/segments/rcp.html",
      "segmentCode": "RCP"
    },
    {
      "id": "segment-rdf",
      "title": "HL7 RDF (Table Row Definition)",
      "description": "Practical guidance for HL7 RDF Table Row Definition, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rdf",
      "sourcePath": "/content/articles/segments/rdf.html",
      "segmentCode": "RDF"
    },
    {
      "id": "segment-rdt",
      "title": "HL7 RDT (Table Row Data)",
      "description": "Practical guidance for HL7 RDT Table Row Data, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rdt",
      "sourcePath": "/content/articles/segments/rdt.html",
      "segmentCode": "RDT"
    },
    {
      "id": "segment-rf1",
      "title": "HL7 RF1 (Referral Information)",
      "description": "Practical guidance for HL7 RF1 Referral Information, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rf1",
      "sourcePath": "/content/articles/segments/rf1.html",
      "segmentCode": "RF1"
    },
    {
      "id": "segment-rgs",
      "title": "HL7 RGS (Resource Group)",
      "description": "Practical guidance for HL7 RGS Resource Group, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rgs",
      "sourcePath": "/content/articles/segments/rgs.html",
      "segmentCode": "RGS"
    },
    {
      "id": "segment-rmi",
      "title": "HL7 RMI (Risk Management Incident)",
      "description": "Practical guidance for HL7 RMI Risk Management Incident, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rmi",
      "sourcePath": "/content/articles/segments/rmi.html",
      "segmentCode": "RMI"
    },
    {
      "id": "segment-rol",
      "title": "HL7 ROL (Role)",
      "description": "Practical guidance for HL7 ROL Role, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rol",
      "sourcePath": "/content/articles/segments/rol.html",
      "segmentCode": "ROL"
    },
    {
      "id": "segment-rq1",
      "title": "HL7 RQ1 (Requisition Detail-1)",
      "description": "Practical guidance for HL7 RQ1 Requisition Detail-1, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rq1",
      "sourcePath": "/content/articles/segments/rq1.html",
      "segmentCode": "RQ1"
    },
    {
      "id": "segment-rqd",
      "title": "HL7 RQD (Requisition Detail)",
      "description": "Practical guidance for HL7 RQD Requisition Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rqd",
      "sourcePath": "/content/articles/segments/rqd.html",
      "segmentCode": "RQD"
    },
    {
      "id": "segment-rxa",
      "title": "HL7 RXA (Pharmacy/Treatment Administration)",
      "description": "Practical guidance for HL7 RXA Pharmacy/Treatment Administration, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rxa",
      "sourcePath": "/content/articles/segments/rxa.html",
      "segmentCode": "RXA"
    },
    {
      "id": "segment-rxc",
      "title": "HL7 RXC (Pharmacy/Treatment Component Order)",
      "description": "Practical guidance for HL7 RXC Pharmacy/Treatment Component Order, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rxc",
      "sourcePath": "/content/articles/segments/rxc.html",
      "segmentCode": "RXC"
    },
    {
      "id": "segment-rxd",
      "title": "HL7 RXD (Pharmacy/Treatment Dispense)",
      "description": "Practical guidance for HL7 RXD Pharmacy/Treatment Dispense, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rxd",
      "sourcePath": "/content/articles/segments/rxd.html",
      "segmentCode": "RXD"
    },
    {
      "id": "segment-rxe",
      "title": "HL7 RXE (Pharmacy/Treatment Encoded Order)",
      "description": "Practical guidance for HL7 RXE Pharmacy/Treatment Encoded Order, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rxe",
      "sourcePath": "/content/articles/segments/rxe.html",
      "segmentCode": "RXE"
    },
    {
      "id": "segment-rxg",
      "title": "HL7 RXG (Pharmacy/Treatment Give)",
      "description": "Practical guidance for HL7 RXG Pharmacy/Treatment Give, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rxg",
      "sourcePath": "/content/articles/segments/rxg.html",
      "segmentCode": "RXG"
    },
    {
      "id": "segment-rxo",
      "title": "HL7 RXO (Pharmacy/Treatment Order)",
      "description": "Practical guidance for HL7 RXO Pharmacy/Treatment Order, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rxo",
      "sourcePath": "/content/articles/segments/rxo.html",
      "segmentCode": "RXO"
    },
    {
      "id": "segment-rxr",
      "title": "HL7 RXR (Pharmacy/Treatment Route)",
      "description": "Practical guidance for HL7 RXR Pharmacy/Treatment Route, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/rxr",
      "sourcePath": "/content/articles/segments/rxr.html",
      "segmentCode": "RXR"
    },
    {
      "id": "segment-sac",
      "title": "HL7 SAC (Specimen Container detail)",
      "description": "Practical guidance for HL7 SAC Specimen Container detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/sac",
      "sourcePath": "/content/articles/segments/sac.html",
      "segmentCode": "SAC"
    },
    {
      "id": "segment-sch",
      "title": "HL7 SCH (Scheduling Activity Information)",
      "description": "The SCH segment of an HL7 SIU message carries appointment identifiers, timing, reasons, contacts, and scheduling status. Here I examine each SCH field and how it is commonly used in real integrations.",
      "category": "segments",
      "route": "/segments/sch",
      "sourcePath": "/content/articles/segments/sch.html",
      "segmentCode": "SCH"
    },
    {
      "id": "segment-sft",
      "title": "HL7 SFT (Software Segment)",
      "description": "Practical guidance for HL7 SFT Software Segment, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/sft",
      "sourcePath": "/content/articles/segments/sft.html",
      "segmentCode": "SFT"
    },
    {
      "id": "segment-sid",
      "title": "HL7 SID (Substance Identifier)",
      "description": "Practical guidance for HL7 SID Substance Identifier, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/sid",
      "sourcePath": "/content/articles/segments/sid.html",
      "segmentCode": "SID"
    },
    {
      "id": "segment-spm",
      "title": "HL7 SPM (Specimen)",
      "description": "The SPM segment of an HL7 message carries specimen identifiers, type, source site, additives, collection method, collection time, received time, rejection, quality, condition, and container details.",
      "category": "segments",
      "route": "/segments/spm",
      "sourcePath": "/content/articles/segments/spm.html",
      "segmentCode": "SPM"
    },
    {
      "id": "segment-spr",
      "title": "HL7 SPR (SPR)",
      "description": "Practical guidance for HL7 SPR SPR, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/spr",
      "sourcePath": "/content/articles/segments/spr.html",
      "segmentCode": "SPR"
    },
    {
      "id": "segment-stf",
      "title": "HL7 STF (Staff Identification)",
      "description": "Practical guidance for HL7 STF Staff Identification, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/stf",
      "sourcePath": "/content/articles/segments/stf.html",
      "segmentCode": "STF"
    },
    {
      "id": "segment-tcc",
      "title": "HL7 TCC (Test Code Configuration)",
      "description": "Practical guidance for HL7 TCC Test Code Configuration, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/tcc",
      "sourcePath": "/content/articles/segments/tcc.html",
      "segmentCode": "TCC"
    },
    {
      "id": "segment-tcd",
      "title": "HL7 TCD (Test Code Detail)",
      "description": "Practical guidance for HL7 TCD Test Code Detail, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/tcd",
      "sourcePath": "/content/articles/segments/tcd.html",
      "segmentCode": "TCD"
    },
    {
      "id": "segment-tq1",
      "title": "HL7 TQ1 (Timing/Quantity)",
      "description": "The TQ1 segment of an HL7 message carries order timing, quantity, frequency, start and end dates, duration, priority, PRN conditions, and occurrence counts.",
      "category": "segments",
      "route": "/segments/tq1",
      "sourcePath": "/content/articles/segments/tq1.html",
      "segmentCode": "TQ1"
    },
    {
      "id": "segment-tq2",
      "title": "HL7 TQ2 (Timing/Quantity Relationship)",
      "description": "The TQ2 segment of an HL7 message links timed service requests together for sequences, cycles, result conditions, related placer and filler orders, and special pharmacy relationships.",
      "category": "segments",
      "route": "/segments/tq2",
      "sourcePath": "/content/articles/segments/tq2.html",
      "segmentCode": "TQ2"
    },
    {
      "id": "segment-txa",
      "title": "HL7 TXA (Transcription Document Header)",
      "description": "The TXA segment of an HL7 MDM message carries document metadata, document identifiers, authors, authenticators, status, availability, confidentiality, and replacement links.",
      "category": "segments",
      "route": "/segments/txa",
      "sourcePath": "/content/articles/segments/txa.html",
      "segmentCode": "TXA"
    },
    {
      "id": "segment-ub1",
      "title": "HL7 UB1 (UB82)",
      "description": "Practical guidance for HL7 UB1 UB82, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ub1",
      "sourcePath": "/content/articles/segments/ub1.html",
      "segmentCode": "UB1"
    },
    {
      "id": "segment-ub2",
      "title": "HL7 UB2 (UB92 Data)",
      "description": "Practical guidance for HL7 UB2 UB92 Data, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/ub2",
      "sourcePath": "/content/articles/segments/ub2.html",
      "segmentCode": "UB2"
    },
    {
      "id": "segment-urd",
      "title": "HL7 URD (Results/update Definition)",
      "description": "Practical guidance for HL7 URD Results/update Definition, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/urd",
      "sourcePath": "/content/articles/segments/urd.html",
      "segmentCode": "URD"
    },
    {
      "id": "segment-urs",
      "title": "HL7 URS (Unsolicited Selection)",
      "description": "Practical guidance for HL7 URS Unsolicited Selection, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/urs",
      "sourcePath": "/content/articles/segments/urs.html",
      "segmentCode": "URS"
    },
    {
      "id": "segment-var",
      "title": "HL7 VAR (Variance)",
      "description": "Practical guidance for HL7 VAR Variance, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/var",
      "sourcePath": "/content/articles/segments/var.html",
      "segmentCode": "VAR"
    },
    {
      "id": "segment-vtq",
      "title": "HL7 VTQ (VTQ)",
      "description": "Practical guidance for HL7 VTQ VTQ, including how the segment is used, which fields matter, and what to watch in real integrations.",
      "category": "segments",
      "route": "/segments/vtq",
      "sourcePath": "/content/articles/segments/vtq.html",
      "segmentCode": "VTQ"
    },
    {
      "id": "message-ack",
      "title": "HL7 ACK (General Acknowledgment)",
      "description": "Practical guide to the HL7 ACK general acknowledgment message, including MSH, MSA, ERR, acceptance codes, retries, and implementation traps.",
      "category": "messages",
      "route": "/messages/ack",
      "sourcePath": "/content/articles/messages/ack.html",
      "messageCode": "ACK",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adr_a19",
      "title": "HL7 ADR_A19 (Patient Query Response)",
      "description": "Practical guide to the HL7 ADR_A19 patient query response, including MSA, QAK, QRD, QRF, PID, PV1, optional patient groups, and older A19 query workflows.",
      "category": "messages",
      "route": "/messages/adr_a19",
      "sourcePath": "/content/articles/messages/adr_a19.html",
      "messageCode": "ADR_A19",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a01",
      "title": "HL7 ADT_A01 (Admit/Visit Notification)",
      "description": "Practical guide to the HL7 ADT_A01 admit or visit notification message, including patient, visit, allergy, diagnosis, guarantor, and insurance groups.",
      "category": "messages",
      "route": "/messages/adt_a01",
      "sourcePath": "/content/articles/messages/adt_a01.html",
      "messageCode": "ADT_A01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a02",
      "title": "HL7 ADT_A02 (Transfer a Patient)",
      "description": "Practical guide to the HL7 ADT_A02 patient transfer message, including visit location changes, EVN timing, PID/PV1 usage, and common transfer traps.",
      "category": "messages",
      "route": "/messages/adt_a02",
      "sourcePath": "/content/articles/messages/adt_a02.html",
      "messageCode": "ADT_A02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a03",
      "title": "HL7 ADT_A03 (Discharge/End Visit)",
      "description": "Practical guide to the HL7 ADT_A03 discharge or end visit message, including visit closure, patient accounting, diagnosis, allergy, procedure, and insurance context.",
      "category": "messages",
      "route": "/messages/adt_a03",
      "sourcePath": "/content/articles/messages/adt_a03.html",
      "messageCode": "ADT_A03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a04",
      "title": "HL7 ADT_A04 (Register a Patient)",
      "description": "Practical guide to the HL7 ADT_A04 register patient event, including ADT^A04^ADT_A01, PID, PV1, outpatient and emergency registration workflows, and common implementation traps.",
      "category": "messages",
      "route": "/messages/adt_a04",
      "sourcePath": "/content/articles/messages/adt_a04.html",
      "messageCode": "ADT_A04",
      "structureCode": "ADT_A01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a05",
      "title": "HL7 ADT_A05 (Pre-Admit a Patient)",
      "description": "Practical guide to the HL7 ADT_A05 pre-admit message, including planned admissions, patient/visit setup, insurance, guarantor, and downstream preparation.",
      "category": "messages",
      "route": "/messages/adt_a05",
      "sourcePath": "/content/articles/messages/adt_a05.html",
      "messageCode": "ADT_A05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a06",
      "title": "HL7 ADT_A06 (Change Outpatient to Inpatient)",
      "description": "Practical guide to HL7 ADT_A06 change outpatient to inpatient messages, including patient class, location, visit, account, and downstream census handling.",
      "category": "messages",
      "route": "/messages/adt_a06",
      "sourcePath": "/content/articles/messages/adt_a06.html",
      "messageCode": "ADT_A06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a08",
      "title": "HL7 ADT_A08 (Update Patient Information)",
      "description": "Practical guide to the HL7 ADT_A08 update patient information event, including ADT^A08^ADT_A01, PID, PV1, demographic updates, encounter updates, and common implementation traps.",
      "category": "messages",
      "route": "/messages/adt_a08",
      "sourcePath": "/content/articles/messages/adt_a08.html",
      "messageCode": "ADT_A08",
      "structureCode": "ADT_A01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a09",
      "title": "HL7 ADT_A09 (Patient Departing - Tracking)",
      "description": "Practical guide to HL7 ADT_A09 patient departing tracking messages, including temporary locations, in-transit handling, PV1 location fields, and ADT tracking traps.",
      "category": "messages",
      "route": "/messages/adt_a09",
      "sourcePath": "/content/articles/messages/adt_a09.html",
      "messageCode": "ADT_A09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a11",
      "title": "HL7 ADT_A11 (Cancel Admit/Visit Notification)",
      "description": "Practical guide to the HL7 ADT_A11 cancel admit or visit notification event, including ADT^A11^ADT_A09, PID, PV1, cancellation behavior, and common implementation traps.",
      "category": "messages",
      "route": "/messages/adt_a11",
      "sourcePath": "/content/articles/messages/adt_a11.html",
      "messageCode": "ADT_A11",
      "structureCode": "ADT_A09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a12",
      "title": "HL7 ADT_A12 (Cancel Transfer)",
      "description": "Practical guide to the HL7 ADT_A12 cancel transfer message, including undoing A02 movements, PV1 location handling, event timing, and correction traps.",
      "category": "messages",
      "route": "/messages/adt_a12",
      "sourcePath": "/content/articles/messages/adt_a12.html",
      "messageCode": "ADT_A12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a13",
      "title": "HL7 ADT_A13 (Cancel Discharge/End Visit)",
      "description": "Practical guide to the HL7 ADT_A13 cancel discharge or end visit event, including ADT^A13^ADT_A01, PID, PV1, reversing A03, and common implementation traps.",
      "category": "messages",
      "route": "/messages/adt_a13",
      "sourcePath": "/content/articles/messages/adt_a13.html",
      "messageCode": "ADT_A13",
      "structureCode": "ADT_A01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a15",
      "title": "HL7 ADT_A15 (Pending Transfer)",
      "description": "Practical guide to HL7 ADT_A15 pending transfer messages, including planned location changes, downstream preparation, PV1/PV2 context, and A02 differences.",
      "category": "messages",
      "route": "/messages/adt_a15",
      "sourcePath": "/content/articles/messages/adt_a15.html",
      "messageCode": "ADT_A15",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a16",
      "title": "HL7 ADT_A16 (Pending Discharge)",
      "description": "Practical guide to HL7 ADT_A16 pending discharge messages, including planned discharge workflows, downstream preparation, PV1/PV2 context, and A03 differences.",
      "category": "messages",
      "route": "/messages/adt_a16",
      "sourcePath": "/content/articles/messages/adt_a16.html",
      "messageCode": "ADT_A16",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a17",
      "title": "HL7 ADT_A17 (Swap Patients)",
      "description": "Practical guide to HL7 ADT_A17 swap patients messages, including repeated PID/PV1 groups, bed exchange handling, and safety traps.",
      "category": "messages",
      "route": "/messages/adt_a17",
      "sourcePath": "/content/articles/messages/adt_a17.html",
      "messageCode": "ADT_A17",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a18",
      "title": "HL7 ADT_A18 (Merge Patient Information)",
      "description": "Practical guide to HL7 ADT_A18 merge patient information messages, including PID, MRG, visit context, deprecation, and safer modern merge events.",
      "category": "messages",
      "route": "/messages/adt_a18",
      "sourcePath": "/content/articles/messages/adt_a18.html",
      "messageCode": "ADT_A18",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a20",
      "title": "HL7 ADT_A20 (Bed Status Update)",
      "description": "Practical guide to HL7 ADT_A20 bed status update messages, including NPU, bed availability, census system updates, and non-patient ADT handling.",
      "category": "messages",
      "route": "/messages/adt_a20",
      "sourcePath": "/content/articles/messages/adt_a20.html",
      "messageCode": "ADT_A20",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a21",
      "title": "HL7 ADT_A21 (Leave of Absence)",
      "description": "Practical guide to HL7 ADT_A21 leave of absence messages, including temporary leave, EVN/PV2 timing, activity holds, and patient still admitted behavior.",
      "category": "messages",
      "route": "/messages/adt_a21",
      "sourcePath": "/content/articles/messages/adt_a21.html",
      "messageCode": "ADT_A21",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a24",
      "title": "HL7 ADT_A24 (Link Patient Information)",
      "description": "Practical guide to HL7 ADT_A24 link patient information messages, including linked identifiers, MPI workflows, repeated PID groups, and merge differences.",
      "category": "messages",
      "route": "/messages/adt_a24",
      "sourcePath": "/content/articles/messages/adt_a24.html",
      "messageCode": "ADT_A24",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a28",
      "title": "HL7 ADT_A28 (Add Person Information)",
      "description": "Practical guide to the HL7 ADT_A28 add person information event, including ADT^A28^ADT_A05, MPI and patient identity feeds, PID, PV1 pseudo-visit handling, and common traps.",
      "category": "messages",
      "route": "/messages/adt_a28",
      "sourcePath": "/content/articles/messages/adt_a28.html",
      "messageCode": "ADT_A28",
      "structureCode": "ADT_A05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a30",
      "title": "HL7 ADT_A30 (Merge Person Information)",
      "description": "Practical guide to HL7 ADT_A30 merge person information messages, including MPI merge context, PID/MRG direction, deprecation, and modern alternatives.",
      "category": "messages",
      "route": "/messages/adt_a30",
      "sourcePath": "/content/articles/messages/adt_a30.html",
      "messageCode": "ADT_A30",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a31",
      "title": "HL7 ADT_A31 (Update Person Information)",
      "description": "Practical guide to the HL7 ADT_A31 update person information event, including ADT^A31^ADT_A05, MPI updates, PID, PV1 pseudo-visit handling, and A31 versus A08.",
      "category": "messages",
      "route": "/messages/adt_a31",
      "sourcePath": "/content/articles/messages/adt_a31.html",
      "messageCode": "ADT_A31",
      "structureCode": "ADT_A05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a37",
      "title": "HL7 ADT_A37 (Unlink Patient Information)",
      "description": "Practical guide to HL7 ADT_A37 unlink patient information messages, including repeated PID groups, MPI unlink workflows, and link versus merge cleanup.",
      "category": "messages",
      "route": "/messages/adt_a37",
      "sourcePath": "/content/articles/messages/adt_a37.html",
      "messageCode": "ADT_A37",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a38",
      "title": "HL7 ADT_A38 (Cancel Pre-Admit)",
      "description": "Practical guide to HL7 ADT_A38 cancel pre-admit messages, including A05 cancellation, visit state cleanup, PID/PV1 context, and downstream traps.",
      "category": "messages",
      "route": "/messages/adt_a38",
      "sourcePath": "/content/articles/messages/adt_a38.html",
      "messageCode": "ADT_A38",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a39",
      "title": "HL7 ADT_A39 (Merge Person - Patient ID)",
      "description": "Practical guide to HL7 ADT_A39 merge person patient ID messages, including deprecated patient ID merge behavior, PID/MRG direction, and modern alternatives.",
      "category": "messages",
      "route": "/messages/adt_a39",
      "sourcePath": "/content/articles/messages/adt_a39.html",
      "messageCode": "ADT_A39",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a40",
      "title": "HL7 ADT_A40 (Merge Patient - Patient Identifier List)",
      "description": "Practical guide to the HL7 ADT_A40 merge patient identifier list event, including ADT^A40^ADT_A39, PID, MRG, target and prior identifiers, and merge safety traps.",
      "category": "messages",
      "route": "/messages/adt_a40",
      "sourcePath": "/content/articles/messages/adt_a40.html",
      "messageCode": "ADT_A40",
      "structureCode": "ADT_A39",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a43",
      "title": "HL7 ADT_A43 (Move Patient Information - Patient Identifier List)",
      "description": "Practical guide to HL7 ADT_A43 move patient information messages, including patient identifier list moves, PID/MRG use, subordinate data movement, and merge differences.",
      "category": "messages",
      "route": "/messages/adt_a43",
      "sourcePath": "/content/articles/messages/adt_a43.html",
      "messageCode": "ADT_A43",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a45",
      "title": "HL7 ADT_A45 (Move Visit Information - Visit Number)",
      "description": "Practical guide to HL7 ADT_A45 move visit information messages, including prior visit number in MRG, target visit/account context in PV1/PID, and move traps.",
      "category": "messages",
      "route": "/messages/adt_a45",
      "sourcePath": "/content/articles/messages/adt_a45.html",
      "messageCode": "ADT_A45",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a50",
      "title": "HL7 ADT_A50 (Change Visit Number)",
      "description": "Practical guide to HL7 ADT_A50 change visit number messages, including prior visit number in MRG, corrected visit in PV1, and identifier safety.",
      "category": "messages",
      "route": "/messages/adt_a50",
      "sourcePath": "/content/articles/messages/adt_a50.html",
      "messageCode": "ADT_A50",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a52",
      "title": "HL7 ADT_A52 (Cancel Leave of Absence)",
      "description": "Practical guide to HL7 ADT_A52 cancel leave of absence messages, including A21 cancellation, EVN timing, patient activity restoration, and LOA traps.",
      "category": "messages",
      "route": "/messages/adt_a52",
      "sourcePath": "/content/articles/messages/adt_a52.html",
      "messageCode": "ADT_A52",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a54",
      "title": "HL7 ADT_A54 (Change Attending Doctor)",
      "description": "Practical guide to HL7 ADT_A54 change attending doctor messages, including PV1-7, provider role context, billing/worklist effects, and A08 differences.",
      "category": "messages",
      "route": "/messages/adt_a54",
      "sourcePath": "/content/articles/messages/adt_a54.html",
      "messageCode": "ADT_A54",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a60",
      "title": "HL7 ADT_A60 (Update Allergy Information)",
      "description": "Practical guide to HL7 ADT_A60 update allergy information messages, including IAM, allergy action codes, visit context, and patient safety handling.",
      "category": "messages",
      "route": "/messages/adt_a60",
      "sourcePath": "/content/articles/messages/adt_a60.html",
      "messageCode": "ADT_A60",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-adt_a61",
      "title": "HL7 ADT_A61 (Change Consulting Doctor)",
      "description": "Practical guide to HL7 ADT_A61 change consulting doctor messages, including PV1-9, provider roles, billing/worklist effects, and A08 differences.",
      "category": "messages",
      "route": "/messages/adt_a61",
      "sourcePath": "/content/articles/messages/adt_a61.html",
      "messageCode": "ADT_A61",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-bar_p01",
      "title": "HL7 BAR_P01 (Add Patient Account)",
      "description": "Practical guide to the HL7 BAR_P01 add patient account message, including patient accounting, account start dates, visit groups, insurance, guarantor, and billing workflow traps.",
      "category": "messages",
      "route": "/messages/bar_p01",
      "sourcePath": "/content/articles/messages/bar_p01.html",
      "messageCode": "BAR_P01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-bar_p02",
      "title": "HL7 BAR_P02 (Purge Patient Accounts)",
      "description": "Practical guide to the HL7 BAR_P02 purge patient accounts message, including account deletion notices, patient/account matching, ACK handling, and financial safety traps.",
      "category": "messages",
      "route": "/messages/bar_p02",
      "sourcePath": "/content/articles/messages/bar_p02.html",
      "messageCode": "BAR_P02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-bar_p05",
      "title": "HL7 BAR_P05 (Update Account)",
      "description": "Practical guide to the HL7 BAR_P05 update account message, including billing account updates, diagnoses, insurance, guarantor, UB data, and inpatient coding context.",
      "category": "messages",
      "route": "/messages/bar_p05",
      "sourcePath": "/content/articles/messages/bar_p05.html",
      "messageCode": "BAR_P05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-bar_p06",
      "title": "HL7 BAR_P06 (End Account)",
      "description": "Practical guide to the HL7 BAR_P06 end account message, including account closure, EVN timing, no-new-charges handling, and billing workflow traps.",
      "category": "messages",
      "route": "/messages/bar_p06",
      "sourcePath": "/content/articles/messages/bar_p06.html",
      "messageCode": "BAR_P06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-bar_p10",
      "title": "HL7 BAR_P10 (Transmit Ambulatory Payment Classification)",
      "description": "Practical guide to the HL7 BAR_P10 APC grouping message, including GP1, GP2, diagnosis, procedure, outpatient reimbursement, and account update traps.",
      "category": "messages",
      "route": "/messages/bar_p10",
      "sourcePath": "/content/articles/messages/bar_p10.html",
      "messageCode": "BAR_P10",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-bar_p12",
      "title": "HL7 BAR_P12 (Update Diagnosis/Procedure)",
      "description": "Practical guide to the HL7 BAR_P12 update diagnosis/procedure message, including DG1, PR1, action codes, account coding updates, and A08 differences.",
      "category": "messages",
      "route": "/messages/bar_p12",
      "sourcePath": "/content/articles/messages/bar_p12.html",
      "messageCode": "BAR_P12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-bps_o29",
      "title": "HL7 BPS_O29 (Blood Product Dispense Status)",
      "description": "Practical guide to the HL7 BPS_O29 blood product dispense status message, including ORC, BPO, BPX, donation IDs, product status, expiration, location, and pre-transfusion workflow traps.",
      "category": "messages",
      "route": "/messages/bps_o29",
      "sourcePath": "/content/articles/messages/bps_o29.html",
      "messageCode": "BPS_O29",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-brp_o30",
      "title": "HL7 BRP_O30 (Blood Product Dispense Status Acknowledgment)",
      "description": "Practical guide to the HL7 BRP_O30 blood product dispense status acknowledgment message, including MSA, ERR, ORC, BPO, BPX, and product-status acceptance handling.",
      "category": "messages",
      "route": "/messages/brp_o30",
      "sourcePath": "/content/articles/messages/brp_o30.html",
      "messageCode": "BRP_O30",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-brt_o32",
      "title": "HL7 BRT_O32 (Blood Product Transfusion/Disposition Acknowledgment)",
      "description": "Practical guide to the HL7 BRT_O32 blood product transfusion/disposition acknowledgment message, including MSA, ERR, ORC, BPO, BTX, final disposition acceptance, and correction handling.",
      "category": "messages",
      "route": "/messages/brt_o32",
      "sourcePath": "/content/articles/messages/brt_o32.html",
      "messageCode": "BRT_O32",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-bts_o31",
      "title": "HL7 BTS_O31 (Blood Product Transfusion/Disposition)",
      "description": "Practical guide to the HL7 BTS_O31 blood product transfusion/disposition message, including ORC, BPO, BTX, transfusion status, adverse reactions, final disposition, and audit workflow.",
      "category": "messages",
      "route": "/messages/bts_o31",
      "sourcePath": "/content/articles/messages/bts_o31.html",
      "messageCode": "BTS_O31",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-crm_c01",
      "title": "HL7 CRM_C01 (Clinical Trial Registration)",
      "description": "Practical guide to the HL7 CRM_C01 clinical trial registration message, including PID, PV1, CSR, CSP, trial enrollment workflows, and downstream system behavior.",
      "category": "messages",
      "route": "/messages/crm_c01",
      "sourcePath": "/content/articles/messages/crm_c01.html",
      "messageCode": "CRM_C01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-csu_c09",
      "title": "HL7 CSU_C09 (Scheduled Clinical Study Data)",
      "description": "Practical guide to the HL7 CSU_C09 automated clinical study data report, including CSR, CSP, CSS, OBR, OBX, RXA, RXR, scheduled reporting, and trial time points.",
      "category": "messages",
      "route": "/messages/csu_c09",
      "sourcePath": "/content/articles/messages/csu_c09.html",
      "messageCode": "CSU_C09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-dft_p03",
      "title": "HL7 DFT_P03 (Post Detail Financial Transaction)",
      "description": "Practical guide to the HL7 DFT_P03 post detail financial transaction message, including FT1, patient/visit context, orders, diagnoses, insurance, guarantor, and charge workflows.",
      "category": "messages",
      "route": "/messages/dft_p03",
      "sourcePath": "/content/articles/messages/dft_p03.html",
      "messageCode": "DFT_P03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-dft_p11",
      "title": "HL7 DFT_P11 (Post Detail Financial Transactions - Expanded/New)",
      "description": "Practical guide to the HL7 DFT_P11 post detail financial transactions expanded/new message, including FT1, DG1, GT1, IN1, PR1, ORC, OBR, and billing workflow traps.",
      "category": "messages",
      "route": "/messages/dft_p11",
      "sourcePath": "/content/articles/messages/dft_p11.html",
      "messageCode": "DFT_P11",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-doc_t12",
      "title": "HL7 DOC_T12 (Document Query Response)",
      "description": "Practical guide to the HL7 DOC_T12 document query response message, including MSA, ERR, QAK, QRD, TXA, OBX, DSC, and document retrieval workflow traps.",
      "category": "messages",
      "route": "/messages/doc_t12",
      "sourcePath": "/content/articles/messages/doc_t12.html",
      "messageCode": "DOC_T12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-dsr_q01",
      "title": "HL7 DSR_Q01 (Immediate Display Response)",
      "description": "Practical guide to the HL7 DSR_Q01 immediate display response message, including MSA, QAK, QRD, QRF, DSP rows, and continuation.",
      "category": "messages",
      "route": "/messages/dsr_q01",
      "sourcePath": "/content/articles/messages/dsr_q01.html",
      "messageCode": "DSR_Q01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-dsr_q03",
      "title": "HL7 DSR_Q03 (Deferred Display Response)",
      "description": "Practical guide to the HL7 DSR_Q03 deferred display response message, including QRD, QRF, DSP rows, continuation, and QCK_Q02 workflows.",
      "category": "messages",
      "route": "/messages/dsr_q03",
      "sourcePath": "/content/articles/messages/dsr_q03.html",
      "messageCode": "DSR_Q03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-eac_u07",
      "title": "HL7 EAC_U07 (Automated Equipment Command)",
      "description": "Practical guide to the HL7 EAC_U07 automated equipment command message, including EQU, ECD, TQ1, SAC, SPM, CNS, command responses, and lab automation control.",
      "category": "messages",
      "route": "/messages/eac_u07",
      "sourcePath": "/content/articles/messages/eac_u07.html",
      "messageCode": "EAC_U07",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ean_u09",
      "title": "HL7 EAN_U09 (Automated Equipment Notification)",
      "description": "Practical guide to the HL7 EAN_U09 automated equipment notification message, including EQU, NDS, NTE, alerts, audit trail, and laboratory automation monitoring.",
      "category": "messages",
      "route": "/messages/ean_u09",
      "sourcePath": "/content/articles/messages/ean_u09.html",
      "messageCode": "EAN_U09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ear_u08",
      "title": "HL7 EAR_U08 (Automated Equipment Response)",
      "description": "Practical guide to the HL7 EAR_U08 automated equipment response message, including EQU, ECD, ECR, command matching, specimen context, and command completion.",
      "category": "messages",
      "route": "/messages/ear_u08",
      "sourcePath": "/content/articles/messages/ear_u08.html",
      "messageCode": "EAR_U08",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-edr_r07",
      "title": "HL7 EDR_R07 (Enhanced Display Response)",
      "description": "Practical guide to the HL7 EDR_R07 enhanced display response message, including MSA, ERR, QAK, DSP, DSC, display responses, and legacy query behavior.",
      "category": "messages",
      "route": "/messages/edr_r07",
      "sourcePath": "/content/articles/messages/edr_r07.html",
      "messageCode": "EDR_R07",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-eqq_q04",
      "title": "HL7 EQQ_Q04 (Embedded Query Language Query)",
      "description": "Practical guide to the HL7 EQQ_Q04 embedded query language query message, including EQL, SQL-like query envelopes, safety cautions, and legacy query handling.",
      "category": "messages",
      "route": "/messages/eqq_q04",
      "sourcePath": "/content/articles/messages/eqq_q04.html",
      "messageCode": "EQQ_Q04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-erp_r09",
      "title": "HL7 ERP_R09 (Event Replay Response)",
      "description": "Practical guide to the HL7 ERP_R09 event replay response message, including MSA, ERR, QAK, ERQ, DSC, replay windows, and legacy query behavior.",
      "category": "messages",
      "route": "/messages/erp_r09",
      "sourcePath": "/content/articles/messages/erp_r09.html",
      "messageCode": "ERP_R09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-esr_u02",
      "title": "HL7 ESR_U02 (Automated Equipment Status Request)",
      "description": "Practical guide to the HL7 ESR_U02 automated equipment status request message, including EQU, status polling, ESU_U01 responses, and ACK choreography.",
      "category": "messages",
      "route": "/messages/esr_u02",
      "sourcePath": "/content/articles/messages/esr_u02.html",
      "messageCode": "ESR_U02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-esu_u01",
      "title": "HL7 ESU_U01 (Automated Equipment Status Update)",
      "description": "Practical guide to the HL7 ESU_U01 automated equipment status update message, including EQU, ISD, equipment state, interaction status, and ACK handling.",
      "category": "messages",
      "route": "/messages/esu_u01",
      "sourcePath": "/content/articles/messages/esu_u01.html",
      "messageCode": "ESU_U01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-inr_u06",
      "title": "HL7 INR_U06 (Automated Equipment Inventory Request)",
      "description": "Practical guide to the HL7 INR_U06 automated equipment inventory request message, including EQU, INV, inventory polling, INU_U05 responses, and analyzer consumables.",
      "category": "messages",
      "route": "/messages/inr_u06",
      "sourcePath": "/content/articles/messages/inr_u06.html",
      "messageCode": "INR_U06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-inu_u05",
      "title": "HL7 INU_U05 (Automated Equipment Inventory Update)",
      "description": "Practical guide to the HL7 INU_U05 automated equipment inventory update message, including EQU, INV, reagent inventory, consumables, quantities, and ACK handling.",
      "category": "messages",
      "route": "/messages/inu_u05",
      "sourcePath": "/content/articles/messages/inu_u05.html",
      "messageCode": "INU_U05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-lsu_u12",
      "title": "HL7 LSU_U12 (Automated Equipment Log/Service Update)",
      "description": "Practical guide to the HL7 LSU_U12 automated equipment log and service update message, including EQU, EQP, audit trail, service events, and equipment maintenance logs.",
      "category": "messages",
      "route": "/messages/lsu_u12",
      "sourcePath": "/content/articles/messages/lsu_u12.html",
      "messageCode": "LSU_U12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mdm_t01",
      "title": "HL7 MDM_T01 (Original Document Notification)",
      "description": "Practical guide to the HL7 MDM_T01 original document notification message, including TXA, EVN, PID, PV1, ORC, OBR, document lifecycle workflow, and no-content notification traps.",
      "category": "messages",
      "route": "/messages/mdm_t01",
      "sourcePath": "/content/articles/messages/mdm_t01.html",
      "messageCode": "MDM_T01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mdm_t02",
      "title": "HL7 MDM_T02 (Original Document Notification and Content)",
      "description": "Practical guide to the HL7 MDM_T02 original document notification and content message, including TXA, OBX, patient/visit context, document status, and report workflows.",
      "category": "messages",
      "route": "/messages/mdm_t02",
      "sourcePath": "/content/articles/messages/mdm_t02.html",
      "messageCode": "MDM_T02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mdm_t06",
      "title": "HL7 MDM_T06 (Document Addendum Notification and Content)",
      "description": "Practical guide to the HL7 MDM_T06 document addendum notification and content message, including MDM^T06^MDM_T02, TXA, OBX, parent documents, and addendum workflow traps.",
      "category": "messages",
      "route": "/messages/mdm_t06",
      "sourcePath": "/content/articles/messages/mdm_t06.html",
      "messageCode": "MDM_T06",
      "structureCode": "MDM_T02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mdm_t08",
      "title": "HL7 MDM_T08 (Document Edit Notification and Content)",
      "description": "Practical guide to the HL7 MDM_T08 document edit notification and content message, including MDM^T08^MDM_T02, TXA, OBX, unavailable documents, and edit workflow traps.",
      "category": "messages",
      "route": "/messages/mdm_t08",
      "sourcePath": "/content/articles/messages/mdm_t08.html",
      "messageCode": "MDM_T08",
      "structureCode": "MDM_T02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mdm_t10",
      "title": "HL7 MDM_T10 (Document Replacement Notification and Content)",
      "description": "Practical guide to the HL7 MDM_T10 document replacement notification and content message, including MDM^T10^MDM_T02, TXA, OBX, parent documents, obsolete originals, and replacement traps.",
      "category": "messages",
      "route": "/messages/mdm_t10",
      "sourcePath": "/content/articles/messages/mdm_t10.html",
      "messageCode": "MDM_T10",
      "structureCode": "MDM_T02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mdm_t11",
      "title": "HL7 MDM_T11 (Document Cancel Notification)",
      "description": "Practical guide to the HL7 MDM_T11 document cancel notification message, including MDM^T11^MDM_T01, TXA, wrong-patient document cancellation, no-content workflow, and cancellation traps.",
      "category": "messages",
      "route": "/messages/mdm_t11",
      "sourcePath": "/content/articles/messages/mdm_t11.html",
      "messageCode": "MDM_T11",
      "structureCode": "MDM_T01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfk_m01",
      "title": "HL7 MFK_M01 (Master File Acknowledgment)",
      "description": "Practical guide to the HL7 MFK_M01 master file acknowledgment message, including MSA, ERR, MFI, MFA, and record-level acknowledgment for MFN master-file feeds.",
      "category": "messages",
      "route": "/messages/mfk_m01",
      "sourcePath": "/content/articles/messages/mfk_m01.html",
      "messageCode": "MFK_M01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m01",
      "title": "HL7 MFN_M01 (Master File Notification)",
      "description": "Practical guide to the HL7 MFN_M01 master file notification message, including MFI, MFE, site-defined record segments, MFK acknowledgments, and legacy master-file update workflows.",
      "category": "messages",
      "route": "/messages/mfn_m01",
      "sourcePath": "/content/articles/messages/mfn_m01.html",
      "messageCode": "MFN_M01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m02",
      "title": "HL7 MFN_M02 (Staff Practitioner Master File)",
      "description": "Practical guide to the HL7 MFN_M02 staff/practitioner master file message, including MFI, MFE, STF, PRA, ORG, AFF, LAN, EDU, CER, and provider-directory synchronization.",
      "category": "messages",
      "route": "/messages/mfn_m02",
      "sourcePath": "/content/articles/messages/mfn_m02.html",
      "messageCode": "MFN_M02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m03",
      "title": "HL7 MFN_M03 (Test/Observation Master File)",
      "description": "Practical guide to the HL7 MFN_M03 test/observation master file message, including MFI, MFE, OM1, and laboratory/radiology test catalog synchronization.",
      "category": "messages",
      "route": "/messages/mfn_m03",
      "sourcePath": "/content/articles/messages/mfn_m03.html",
      "messageCode": "MFN_M03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m04",
      "title": "HL7 MFN_M04 (Charge Description Master File)",
      "description": "Practical guide to the HL7 MFN_M04 charge description master file message, including MFI, MFE, CDM, PRC, billing catalog updates, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m04",
      "sourcePath": "/content/articles/messages/mfn_m04.html",
      "messageCode": "MFN_M04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m05",
      "title": "HL7 MFN_M05 (Patient Location Master File)",
      "description": "Practical guide to the HL7 MFN_M05 patient location master file message, including LOC, LCH, LRL, LDP, LCC, location hierarchy, department use, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m05",
      "sourcePath": "/content/articles/messages/mfn_m05.html",
      "messageCode": "MFN_M05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m06",
      "title": "HL7 MFN_M06 (Clinical Study with Phases and Schedules)",
      "description": "Practical guide to the HL7 MFN_M06 clinical study with phases and schedules master file message, including CM0, CM1, CM2, study catalog updates, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m06",
      "sourcePath": "/content/articles/messages/mfn_m06.html",
      "messageCode": "MFN_M06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m07",
      "title": "HL7 MFN_M07 (Clinical Study without Phases but with Schedules)",
      "description": "Practical guide to the HL7 MFN_M07 clinical study without phases but with schedules master file message, including CM0, CM2, study schedule updates, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m07",
      "sourcePath": "/content/articles/messages/mfn_m07.html",
      "messageCode": "MFN_M07",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m08",
      "title": "HL7 MFN_M08 (Test/Observation Numeric Master File)",
      "description": "Practical guide to the HL7 MFN_M08 test/observation numeric master file message, including OM1, OM2, OM3, OM4, numeric result catalog updates, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m08",
      "sourcePath": "/content/articles/messages/mfn_m08.html",
      "messageCode": "MFN_M08",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m09",
      "title": "HL7 MFN_M09 (Test/Observation Categorical Master File)",
      "description": "Practical guide to the HL7 MFN_M09 categorical test/observation master file message, including OM1, OM3, OM4, coded answer lists, specimen requirements, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m09",
      "sourcePath": "/content/articles/messages/mfn_m09.html",
      "messageCode": "MFN_M09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m10",
      "title": "HL7 MFN_M10 (Test/Observation Batteries Master File)",
      "description": "Practical guide to the HL7 MFN_M10 observation batteries master file message, including OM1, OM5, OM4, panel membership, specimens, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m10",
      "sourcePath": "/content/articles/messages/mfn_m10.html",
      "messageCode": "MFN_M10",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m11",
      "title": "HL7 MFN_M11 (Calculated Observations Master File)",
      "description": "Practical guide to the HL7 MFN_M11 calculated observations master file message, including OM1, OM6, OM2, derivation rules, numeric attributes, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m11",
      "sourcePath": "/content/articles/messages/mfn_m11.html",
      "messageCode": "MFN_M11",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m12",
      "title": "HL7 MFN_M12 (Additional Basic Observation Attributes)",
      "description": "Practical guide to the HL7 MFN_M12 additional basic observation/service attributes master file message, including OM1, OM7, service attributes, consent, locations, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m12",
      "sourcePath": "/content/articles/messages/mfn_m12.html",
      "messageCode": "MFN_M12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m13",
      "title": "HL7 MFN_M13 (General Master File Notification)",
      "description": "Practical guide to the HL7 MFN_M13 general master file notification message, including MFI, MFE, simple key/text master files, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m13",
      "sourcePath": "/content/articles/messages/mfn_m13.html",
      "messageCode": "MFN_M13",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_m15",
      "title": "HL7 MFN_M15 (Inventory Item Master File)",
      "description": "Practical guide to the HL7 MFN_M15 inventory item master file notification message, including MFI, MFE, IIM, lot numbers, expiration dates, quantities, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_m15",
      "sourcePath": "/content/articles/messages/mfn_m15.html",
      "messageCode": "MFN_M15",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfn_znn",
      "title": "HL7 MFN_Znn (Site-Defined Master File Notification)",
      "description": "Practical guide to the HL7 MFN_Znn site-defined master file notification message, including MFI, MFE, Z segments, local master files, and MFK acknowledgments.",
      "category": "messages",
      "route": "/messages/mfn_znn",
      "sourcePath": "/content/articles/messages/mfn_znn.html",
      "messageCode": "MFN_Znn",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfq_m01",
      "title": "HL7 MFQ_M01 (Master Files Query)",
      "description": "Practical guide to the HL7 MFQ_M01 master files query message, including QRD, QRF, DSC, and older master-file query workflows.",
      "category": "messages",
      "route": "/messages/mfq_m01",
      "sourcePath": "/content/articles/messages/mfq_m01.html",
      "messageCode": "MFQ_M01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfr_m01",
      "title": "HL7 MFR_M01 (Master Files Query Response)",
      "description": "Practical guide to the HL7 MFR_M01 master files query response message, including MSA, QAK, QRD, QRF, MFI, MFE, DSC, and returned master-file records.",
      "category": "messages",
      "route": "/messages/mfr_m01",
      "sourcePath": "/content/articles/messages/mfr_m01.html",
      "messageCode": "MFR_M01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfr_m04",
      "title": "HL7 MFR_M04 (Charge Description Master File Response)",
      "description": "Practical guide to the HL7 MFR_M04 charge description master file response message, including MSA, QAK, QRD, QRF, MFI, MFE, CDM, PRC, and continuation handling.",
      "category": "messages",
      "route": "/messages/mfr_m04",
      "sourcePath": "/content/articles/messages/mfr_m04.html",
      "messageCode": "MFR_M04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfr_m05",
      "title": "HL7 MFR_M05 (Patient Location Master File Response)",
      "description": "Practical guide to the HL7 MFR_M05 patient location master file response message, including MSA, QAK, QRD, MFI, MFE, LOC, LCH, LRL, LDP, LCC, and continuation handling.",
      "category": "messages",
      "route": "/messages/mfr_m05",
      "sourcePath": "/content/articles/messages/mfr_m05.html",
      "messageCode": "MFR_M05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfr_m06",
      "title": "HL7 MFR_M06 (Clinical Study Phases and Schedules Response)",
      "description": "Practical guide to the HL7 MFR_M06 clinical study with phases and schedules master file response message, including MSA, QAK, QRD, MFI, MFE, CM0, CM1, CM2, and continuation handling.",
      "category": "messages",
      "route": "/messages/mfr_m06",
      "sourcePath": "/content/articles/messages/mfr_m06.html",
      "messageCode": "MFR_M06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-mfr_m07",
      "title": "HL7 MFR_M07 (Clinical Study Schedules Response)",
      "description": "Practical guide to the HL7 MFR_M07 clinical study without phases but with schedules master file response message, including MSA, QAK, QRD, MFI, MFE, CM0, CM2, and continuation handling.",
      "category": "messages",
      "route": "/messages/mfr_m07",
      "sourcePath": "/content/articles/messages/mfr_m07.html",
      "messageCode": "MFR_M07",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-nmd_n02",
      "title": "HL7 NMD_N02 (Application Management Data)",
      "description": "Practical guide to the HL7 NMD_N02 unsolicited application management data message, including NCK, NST, NSC, NTE, status changes, clock data, and interface operations.",
      "category": "messages",
      "route": "/messages/nmd_n02",
      "sourcePath": "/content/articles/messages/nmd_n02.html",
      "messageCode": "NMD_N02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-nmq_n01",
      "title": "HL7 NMQ_N01 (Application Management Query)",
      "description": "Practical guide to the HL7 NMQ_N01 application management query message, including QRD, QRF, NCK, NST, NSC, clock/status/statistics requests, and operational monitoring.",
      "category": "messages",
      "route": "/messages/nmq_n01",
      "sourcePath": "/content/articles/messages/nmq_n01.html",
      "messageCode": "NMQ_N01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-nmr_n01",
      "title": "HL7 NMR_N01 (Application Management Response)",
      "description": "Practical guide to the HL7 NMR_N01 application management response message, including MSA, ERR, QRD, NCK, NST, NSC, NTE, status responses, and monitoring workflows.",
      "category": "messages",
      "route": "/messages/nmr_n01",
      "sourcePath": "/content/articles/messages/nmr_n01.html",
      "messageCode": "NMR_N01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-omb_o27",
      "title": "HL7 OMB_O27 (Blood Product Order)",
      "description": "Practical guide to the HL7 OMB_O27 blood product order message, including patient context, ORC, BPO, specimen, diagnosis, observations, billing, and ORB acknowledgments.",
      "category": "messages",
      "route": "/messages/omb_o27",
      "sourcePath": "/content/articles/messages/omb_o27.html",
      "messageCode": "OMB_O27",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-omd_o03",
      "title": "HL7 OMD_O03 (Diet Order)",
      "description": "Practical guide to the HL7 OMD_O03 diet order message, including patient context, ORC, ODS, ODT, timing, tray instructions, supplements, preferences, and diet-order traps.",
      "category": "messages",
      "route": "/messages/omd_o03",
      "sourcePath": "/content/articles/messages/omd_o03.html",
      "messageCode": "OMD_O03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-omg_o19",
      "title": "HL7 OMG_O19 (General Clinical Order)",
      "description": "Practical guide to the HL7 OMG_O19 general clinical order message, including ORC, OBR, TQ1, OBX, specimen context, order control, and response handling.",
      "category": "messages",
      "route": "/messages/omg_o19",
      "sourcePath": "/content/articles/messages/omg_o19.html",
      "messageCode": "OMG_O19",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-omi_o23",
      "title": "HL7 OMI_O23 (Imaging Order)",
      "description": "Practical guide to the HL7 OMI_O23 imaging order message, including ORC, OBR, IPC, RIS/PACS workflows, imaging identifiers, and order traps.",
      "category": "messages",
      "route": "/messages/omi_o23",
      "sourcePath": "/content/articles/messages/omi_o23.html",
      "messageCode": "OMI_O23",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oml_o21",
      "title": "HL7 OML_O21 (Laboratory Order)",
      "description": "Practical guide to the HL7 OML_O21 laboratory order message, including ORC, OBR, SPM, SAC, prior results, patient groups, and lab automation usage.",
      "category": "messages",
      "route": "/messages/oml_o21",
      "sourcePath": "/content/articles/messages/oml_o21.html",
      "messageCode": "OML_O21",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oml_o33",
      "title": "HL7 OML_O33 (Lab Orders for One Specimen)",
      "description": "Practical guide to the HL7 OML_O33 laboratory order message, including specimen-centric ordering, SPM, SAC, ORC, OBR, multiple orders per specimen, and lab automation traps.",
      "category": "messages",
      "route": "/messages/oml_o33",
      "sourcePath": "/content/articles/messages/oml_o33.html",
      "messageCode": "OML_O33",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oml_o35",
      "title": "HL7 OML_O35 (Lab Orders for One Container)",
      "description": "Practical guide to the HL7 OML_O35 laboratory order message, including specimen-container-centered ordering, SPM, SAC, ORC, OBR, and lab automation traps.",
      "category": "messages",
      "route": "/messages/oml_o35",
      "sourcePath": "/content/articles/messages/oml_o35.html",
      "messageCode": "OML_O35",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-omn_o07",
      "title": "HL7 OMN_O07 (Non-Stock Requisition Order)",
      "description": "Practical guide to the HL7 OMN_O07 non-stock requisition order message, including ORC, RQD, RQ1, vendor catalog detail, substitutions, and ORN acknowledgments.",
      "category": "messages",
      "route": "/messages/omn_o07",
      "sourcePath": "/content/articles/messages/omn_o07.html",
      "messageCode": "OMN_O07",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-omp_o09",
      "title": "HL7 OMP_O09 (Pharmacy/Treatment Order)",
      "description": "Practical guide to the HL7 OMP_O09 pharmacy/treatment order message, including ORC, RXO, RXR, RXC, timing, patient context, and medication-order traps.",
      "category": "messages",
      "route": "/messages/omp_o09",
      "sourcePath": "/content/articles/messages/omp_o09.html",
      "messageCode": "OMP_O09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oms_o05",
      "title": "HL7 OMS_O05 (Stock Requisition Order)",
      "description": "Practical guide to the HL7 OMS_O05 stock requisition order message, including ORC, RQD, RQ1, inventory quantities, delivery location, billing, and ORS acknowledgments.",
      "category": "messages",
      "route": "/messages/oms_o05",
      "sourcePath": "/content/articles/messages/oms_o05.html",
      "messageCode": "OMS_O05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orb_o28",
      "title": "HL7 ORB_O28 (Blood Product Order Acknowledgment)",
      "description": "Practical guide to the HL7 ORB_O28 blood product order acknowledgment message, including MSA, ERR, ORC, BPO, filler identifiers, and blood bank acceptance handling.",
      "category": "messages",
      "route": "/messages/orb_o28",
      "sourcePath": "/content/articles/messages/orb_o28.html",
      "messageCode": "ORB_O28",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ord_o04",
      "title": "HL7 ORD_O04 (Diet Order Acknowledgment)",
      "description": "Practical guide to the HL7 ORD_O04 diet order acknowledgment message, including MSA, ERR, ORC, ODS, ODT, response groups, and diet-order acceptance handling.",
      "category": "messages",
      "route": "/messages/ord_o04",
      "sourcePath": "/content/articles/messages/ord_o04.html",
      "messageCode": "ORD_O04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orf_r04",
      "title": "HL7 ORF_R04 (Response to Query for Results)",
      "description": "Practical guide to the HL7 ORF_R04 response to query for results message, including MSA, QRD, QRF, PID, ORC, OBR, OBX, QAK, and solicited observation workflows.",
      "category": "messages",
      "route": "/messages/orf_r04",
      "sourcePath": "/content/articles/messages/orf_r04.html",
      "messageCode": "ORF_R04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-org_o20",
      "title": "HL7 ORG_O20 (General Clinical Order Response)",
      "description": "Practical guide to the HL7 ORG_O20 general clinical order response message, including MSA, ERR, ORC, OBR, order acceptance, rejection, and filler identifiers.",
      "category": "messages",
      "route": "/messages/org_o20",
      "sourcePath": "/content/articles/messages/org_o20.html",
      "messageCode": "ORG_O20",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ori_o24",
      "title": "HL7 ORI_O24 (Imaging Order Response)",
      "description": "Practical guide to the HL7 ORI_O24 imaging order response message, including MSA, ERR, ORC, OBR, IPC, accession identifiers, and RIS acknowledgment workflows.",
      "category": "messages",
      "route": "/messages/ori_o24",
      "sourcePath": "/content/articles/messages/ori_o24.html",
      "messageCode": "ORI_O24",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orl_o22",
      "title": "HL7 ORL_O22 (General Laboratory Order Response)",
      "description": "Practical guide to the HL7 ORL_O22 general laboratory order response message, including MSA, ERR, PID, ORC, OBR, SPM, SAC, and OML response workflows.",
      "category": "messages",
      "route": "/messages/orl_o22",
      "sourcePath": "/content/articles/messages/orl_o22.html",
      "messageCode": "ORL_O22",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orl_o34",
      "title": "HL7 ORL_O34 (Lab Order Response for One Specimen)",
      "description": "Practical guide to the HL7 ORL_O34 laboratory order response message, including MSA, ERR, SPM, SAC, ORC, OBR, multiple orders per specimen, and lab acceptance workflows.",
      "category": "messages",
      "route": "/messages/orl_o34",
      "sourcePath": "/content/articles/messages/orl_o34.html",
      "messageCode": "ORL_O34",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orl_o36",
      "title": "HL7 ORL_O36 (Lab Order Response for One Container)",
      "description": "Practical guide to the HL7 ORL_O36 laboratory order response message, including MSA, ERR, SPM, SAC, ORC, OBR, container-level acknowledgments, and lab workflow traps.",
      "category": "messages",
      "route": "/messages/orl_o36",
      "sourcePath": "/content/articles/messages/orl_o36.html",
      "messageCode": "ORL_O36",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orm_o01",
      "title": "HL7 ORM_O01 (Order Message)",
      "description": "Practical guide to the HL7 ORM_O01 order message, including patient, visit, ORC, OBR, OBX, order detail, diagnosis, billing, and common order workflow traps.",
      "category": "messages",
      "route": "/messages/orm_o01",
      "sourcePath": "/content/articles/messages/orm_o01.html",
      "messageCode": "ORM_O01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orn_o08",
      "title": "HL7 ORN_O08 (Non-Stock Requisition Acknowledgment)",
      "description": "Practical guide to the HL7 ORN_O08 non-stock requisition acknowledgment message, including MSA, ERR, ORC, RQD, RQ1, vendor detail, and purchasing acceptance.",
      "category": "messages",
      "route": "/messages/orn_o08",
      "sourcePath": "/content/articles/messages/orn_o08.html",
      "messageCode": "ORN_O08",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orp_o10",
      "title": "HL7 ORP_O10 (Pharmacy/Treatment Order Acknowledgment)",
      "description": "Practical guide to the HL7 ORP_O10 pharmacy/treatment order acknowledgment message, including MSA, ERR, ORC, RXO, RXR, RXC, and medication-order response workflows.",
      "category": "messages",
      "route": "/messages/orp_o10",
      "sourcePath": "/content/articles/messages/orp_o10.html",
      "messageCode": "ORP_O10",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-orr_o02",
      "title": "HL7 ORR_O02 (Order Response)",
      "description": "Practical guide to the HL7 ORR_O02 order response message, including MSA, ERR, ORC, OBR, order acknowledgment, filler order numbers, and ORM response traps.",
      "category": "messages",
      "route": "/messages/orr_o02",
      "sourcePath": "/content/articles/messages/orr_o02.html",
      "messageCode": "ORR_O02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ors_o06",
      "title": "HL7 ORS_O06 (Stock Requisition Acknowledgment)",
      "description": "Practical guide to the HL7 ORS_O06 stock requisition acknowledgment message, including MSA, ERR, ORC, RQD, RQ1, and fulfillment identifier handling.",
      "category": "messages",
      "route": "/messages/ors_o06",
      "sourcePath": "/content/articles/messages/ors_o06.html",
      "messageCode": "ORS_O06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oru_r01",
      "title": "HL7 ORU_R01 (Observation Result)",
      "description": "Practical guide to the HL7 ORU_R01 unsolicited observation result message, including patient result, order observation, OBR, OBX, SPM, notes, status, and result traps.",
      "category": "messages",
      "route": "/messages/oru_r01",
      "sourcePath": "/content/articles/messages/oru_r01.html",
      "messageCode": "ORU_R01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oru_r30",
      "title": "HL7 ORU_R30 (Point-of-Care Observation, Place an Order)",
      "description": "Practical guide to the HL7 ORU_R30 point-of-care observation message without an existing order, including ORC, OBR, OBX, patient/visit context, and ACK/order creation traps.",
      "category": "messages",
      "route": "/messages/oru_r30",
      "sourcePath": "/content/articles/messages/oru_r30.html",
      "messageCode": "ORU_R30",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-osq_q06",
      "title": "HL7 OSQ_Q06 (Order Status Query)",
      "description": "Practical guide to the HL7 OSQ_Q06 order status query message, including QRD, QRF, order identifiers, original-mode query behavior, and OSR_Q06 responses.",
      "category": "messages",
      "route": "/messages/osq_q06",
      "sourcePath": "/content/articles/messages/osq_q06.html",
      "messageCode": "OSQ_Q06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-osr_q06",
      "title": "HL7 OSR_Q06 (Order Status Response)",
      "description": "Practical guide to the HL7 OSR_Q06 order status response message, including MSA, ERR, QRD, QRF, ORC, timing, order detail, and continuation.",
      "category": "messages",
      "route": "/messages/osr_q06",
      "sourcePath": "/content/articles/messages/osr_q06.html",
      "messageCode": "OSR_Q06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oul_r21",
      "title": "HL7 OUL_R21 (Unsolicited Laboratory Observation)",
      "description": "Practical guide to the HL7 OUL_R21 unsolicited laboratory observation message, including OBR, OBX, SAC, lab automation, backward compatibility, and OUL grouping traps.",
      "category": "messages",
      "route": "/messages/oul_r21",
      "sourcePath": "/content/articles/messages/oul_r21.html",
      "messageCode": "OUL_R21",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oul_r22",
      "title": "HL7 OUL_R22 (Specimen-Oriented Observation)",
      "description": "Practical guide to the HL7 OUL_R22 unsolicited specimen-oriented observation message, including SPM, SAC, OBR, OBX, container groups, and lab automation result workflows.",
      "category": "messages",
      "route": "/messages/oul_r22",
      "sourcePath": "/content/articles/messages/oul_r22.html",
      "messageCode": "OUL_R22",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oul_r23",
      "title": "HL7 OUL_R23 (Specimen Container-Oriented Observation)",
      "description": "Practical guide to the HL7 OUL_R23 unsolicited specimen container-oriented observation message, including SPM, SAC, INV, OBR, OBX, and lab automation traceability.",
      "category": "messages",
      "route": "/messages/oul_r23",
      "sourcePath": "/content/articles/messages/oul_r23.html",
      "messageCode": "OUL_R23",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-oul_r24",
      "title": "HL7 OUL_R24 (Order-Oriented Observation)",
      "description": "Practical guide to the HL7 OUL_R24 unsolicited order-oriented observation message, including multi-specimen lab results, OBR, SPM, SAC, OBX, and automation traceability.",
      "category": "messages",
      "route": "/messages/oul_r24",
      "sourcePath": "/content/articles/messages/oul_r24.html",
      "messageCode": "OUL_R24",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-pex_p07",
      "title": "HL7 PEX_P07 (Initial Product Experience Report)",
      "description": "Practical guide to the HL7 PEX_P07 unsolicited initial individual product experience report, including PES, PEO, PCR, RXE, RXA, OBX, and safety reporting workflows.",
      "category": "messages",
      "route": "/messages/pex_p07",
      "sourcePath": "/content/articles/messages/pex_p07.html",
      "messageCode": "PEX_P07",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-pgl_pc6",
      "title": "HL7 PGL_PC6 (Patient Goal Message)",
      "description": "Practical guide to the HL7 PGL_PC6 patient goal add message, including PID, PV1, GOL, ROL, PTH, OBX, PRB, ORC, care goals, and patient-care workflows.",
      "category": "messages",
      "route": "/messages/pgl_pc6",
      "sourcePath": "/content/articles/messages/pgl_pc6.html",
      "messageCode": "PGL_PC6",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-pmu_b01",
      "title": "HL7 PMU_B01 (Add Personnel Record)",
      "description": "Practical guide to the HL7 PMU_B01 add personnel record message, including EVN, STF, PRA, ORG, AFF, LAN, EDU, CER, and personnel-management workflow cautions.",
      "category": "messages",
      "route": "/messages/pmu_b01",
      "sourcePath": "/content/articles/messages/pmu_b01.html",
      "messageCode": "PMU_B01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-pmu_b03",
      "title": "HL7 PMU_B03 (Delete Personnel Record)",
      "description": "Practical guide to the HL7 PMU_B03 delete personnel record message, including EVN, STF, ACK handling, and the difference between deletion, inactivation, and termination.",
      "category": "messages",
      "route": "/messages/pmu_b03",
      "sourcePath": "/content/articles/messages/pmu_b03.html",
      "messageCode": "PMU_B03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-pmu_b04",
      "title": "HL7 PMU_B04 (Active Practicing Person)",
      "description": "Practical guide to the HL7 PMU_B04 active practicing person message, including EVN, STF, PRA, ORG, active flags, scheduling availability, and ACK handling.",
      "category": "messages",
      "route": "/messages/pmu_b04",
      "sourcePath": "/content/articles/messages/pmu_b04.html",
      "messageCode": "PMU_B04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-pmu_b07",
      "title": "HL7 PMU_B07 (Grant Certificate Permission)",
      "description": "Practical guide to the HL7 PMU_B07 grant certificate or permission message, including EVN, STF, PRA, CER, ROL, credentialing, role scope, and ACK handling.",
      "category": "messages",
      "route": "/messages/pmu_b07",
      "sourcePath": "/content/articles/messages/pmu_b07.html",
      "messageCode": "PMU_B07",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-pmu_b08",
      "title": "HL7 PMU_B08 (Revoke Certificate Permission)",
      "description": "Practical guide to the HL7 PMU_B08 revoke certificate or permission message, including EVN, STF, PRA, CER, revocation handling, downstream access, and ACK handling.",
      "category": "messages",
      "route": "/messages/pmu_b08",
      "sourcePath": "/content/articles/messages/pmu_b08.html",
      "messageCode": "PMU_B08",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ppg_pcg",
      "title": "HL7 PPG_PCG (Patient Pathway Message, Goal-Oriented)",
      "description": "Practical guide to the HL7 PPG_PCG patient pathway goal-oriented add message, including PID, PV1, PTH, ROL, GOL, OBX, PRB, ORC, and pathway care-plan context.",
      "category": "messages",
      "route": "/messages/ppg_pcg",
      "sourcePath": "/content/articles/messages/ppg_pcg.html",
      "messageCode": "PPG_PCG",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ppp_pcb",
      "title": "HL7 PPP_PCB (Patient Pathway Message, Problem-Oriented)",
      "description": "Practical guide to the HL7 PPP_PCB patient pathway problem-oriented add message, including PID, PV1, PTH, ROL, PRB, OBX, GOL, ORC, and pathway care-plan context.",
      "category": "messages",
      "route": "/messages/ppp_pcb",
      "sourcePath": "/content/articles/messages/ppp_pcb.html",
      "messageCode": "PPP_PCB",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ppr_pc1",
      "title": "HL7 PPR_PC1 (Patient Problem Message)",
      "description": "Practical guide to the HL7 PPR_PC1 patient problem add message, including PID, PV1, PRB, ROL, PTH, OBX, GOL, ORC, problem lists, goals, and care-plan context.",
      "category": "messages",
      "route": "/messages/ppr_pc1",
      "sourcePath": "/content/articles/messages/ppr_pc1.html",
      "messageCode": "PPR_PC1",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ppt_pcl",
      "title": "HL7 PPT_PCL (Patient Pathway Response, Goal-Oriented)",
      "description": "Practical guide to the HL7 PPT_PCL patient pathway goal-oriented response message, including MSA, QAK, QRD, PID, PV1, PTH, GOL, PRB, OBX, and old-style pathway query responses.",
      "category": "messages",
      "route": "/messages/ppt_pcl",
      "sourcePath": "/content/articles/messages/ppt_pcl.html",
      "messageCode": "PPT_PCL",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ppv_pca",
      "title": "HL7 PPV_PCA (Patient Goal Response)",
      "description": "Practical guide to the HL7 PPV_PCA patient goal response message, including MSA, QAK, QRD, PID, PV1, GOL, PTH, OBX, PRB, and old-style patient-care goal query handling.",
      "category": "messages",
      "route": "/messages/ppv_pca",
      "sourcePath": "/content/articles/messages/ppv_pca.html",
      "messageCode": "PPV_PCA",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-prr_pc5",
      "title": "HL7 PRR_PC5 (Patient Problem Response)",
      "description": "Practical guide to the HL7 PRR_PC5 patient problem response message, including MSA, QAK, QRD, PID, PV1, PRB, PTH, OBX, GOL, and old-style patient-care query handling.",
      "category": "messages",
      "route": "/messages/prr_pc5",
      "sourcePath": "/content/articles/messages/prr_pc5.html",
      "messageCode": "PRR_PC5",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ptr_pcf",
      "title": "HL7 PTR_PCF (Patient Pathway Response, Problem-Oriented)",
      "description": "Practical guide to the HL7 PTR_PCF patient pathway problem-oriented response message, including MSA, QAK, QRD, PID, PV1, PTH, PRB, GOL, OBX, and old-style pathway query responses.",
      "category": "messages",
      "route": "/messages/ptr_pcf",
      "sourcePath": "/content/articles/messages/ptr_pcf.html",
      "messageCode": "PTR_PCF",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qbp_q11",
      "title": "HL7 QBP_Q11 (Query by Parameter)",
      "description": "Practical guide to the HL7 QBP_Q11 query by parameter message, including QPD, RCP, DSC, query tags, and segment-pattern response workflows.",
      "category": "messages",
      "route": "/messages/qbp_q11",
      "sourcePath": "/content/articles/messages/qbp_q11.html",
      "messageCode": "QBP_Q11",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qbp_q13",
      "title": "HL7 QBP_Q13 (Tabular Query)",
      "description": "Practical guide to the HL7 QBP_Q13 query by parameter message for RTB tabular responses, including QPD, RDF, RCP, DSC, and output column agreements.",
      "category": "messages",
      "route": "/messages/qbp_q13",
      "sourcePath": "/content/articles/messages/qbp_q13.html",
      "messageCode": "QBP_Q13",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qbp_q15",
      "title": "HL7 QBP_Q15 (Display Query)",
      "description": "Practical guide to the HL7 QBP_Q15 query by parameter message for RDY display responses, including QPD, RCP, DSC, and display-oriented query profiles.",
      "category": "messages",
      "route": "/messages/qbp_q15",
      "sourcePath": "/content/articles/messages/qbp_q15.html",
      "messageCode": "QBP_Q15",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qbp_q21",
      "title": "HL7 QBP_Q21 (Get Person Demographics)",
      "description": "Practical guide to the HL7 QBP_Q21 get person demographics query, including QPD, RCP, patient identifiers, demographics lookup workflows, and response handling.",
      "category": "messages",
      "route": "/messages/qbp_q21",
      "sourcePath": "/content/articles/messages/qbp_q21.html",
      "messageCode": "QBP_Q21",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qbp_q23",
      "title": "HL7 QBP_Q23 (Get Corresponding Identifiers)",
      "description": "Practical guide to the HL7 QBP_Q23 get corresponding identifiers query, including QBP^Q23^QBP_Q21, QPD parameters, assigning authorities, PIX-style workflows, and response handling.",
      "category": "messages",
      "route": "/messages/qbp_q23",
      "sourcePath": "/content/articles/messages/qbp_q23.html",
      "messageCode": "QBP_Q23",
      "structureCode": "QBP_Q21",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qbp_q25",
      "title": "HL7 QBP_Q25 (Personnel Information Query)",
      "description": "Practical guide to the HL7 QBP_Q25 personnel information query, including QBP^Q25^QBP_Q21, QPD, RCP, staff lookup workflows, and RSP_K25 responses.",
      "category": "messages",
      "route": "/messages/qbp_q25",
      "sourcePath": "/content/articles/messages/qbp_q25.html",
      "messageCode": "QBP_Q25",
      "structureCode": "QBP_Q21",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qbp_qnn",
      "title": "HL7 QBP_Qnn (Generic Query by Parameter)",
      "description": "Practical guide to the generic HL7 QBP_Qnn query by parameter message, including QPD, RCP, optional RDF, DSC, query tags, and local query profiles.",
      "category": "messages",
      "route": "/messages/qbp_qnn",
      "sourcePath": "/content/articles/messages/qbp_qnn.html",
      "messageCode": "QBP_Qnn",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qbp_z73",
      "title": "HL7 QBP_Z73 (Information about Phone Calls)",
      "description": "Practical guide to the HL7 QBP_Z73 information about phone calls query, including QPD, RCP, phone-call charging workflows, and RTB_Z74 tabular responses.",
      "category": "messages",
      "route": "/messages/qbp_z73",
      "sourcePath": "/content/articles/messages/qbp_z73.html",
      "messageCode": "QBP_Z73",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qck_q02",
      "title": "HL7 QCK_Q02 (Deferred Query Acknowledgment)",
      "description": "Practical guide to the HL7 QCK_Q02 deferred query acknowledgment message, including MSA, ERR, QAK, and later DSR_Q03 response handling.",
      "category": "messages",
      "route": "/messages/qck_q02",
      "sourcePath": "/content/articles/messages/qck_q02.html",
      "messageCode": "QCK_Q02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qcn_j01",
      "title": "HL7 QCN_J01 (Cancel Query)",
      "description": "Practical guide to the HL7 QCN_J01 cancel query message, including QID, continuation cleanup, ACK handling, and query tag matching.",
      "category": "messages",
      "route": "/messages/qcn_j01",
      "sourcePath": "/content/articles/messages/qcn_j01.html",
      "messageCode": "QCN_J01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qry_a19",
      "title": "HL7 QRY_A19 (Patient Query)",
      "description": "Practical guide to the HL7 QRY_A19 patient query message, including QRD, QRF, older patient lookup workflows, ADR_A19 responses, and migration traps.",
      "category": "messages",
      "route": "/messages/qry_a19",
      "sourcePath": "/content/articles/messages/qry_a19.html",
      "messageCode": "QRY_A19",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qry_pc4",
      "title": "HL7 QRY_PC4 (Patient Care Problem Query)",
      "description": "Practical guide to the HL7 QRY_PC4 patient care problem query message, including QRD, QRF, problem-list workflows, and legacy patient care query behavior.",
      "category": "messages",
      "route": "/messages/qry_pc4",
      "sourcePath": "/content/articles/messages/qry_pc4.html",
      "messageCode": "QRY_PC4",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qry_q01",
      "title": "HL7 QRY_Q01 (Immediate Query)",
      "description": "Practical guide to the HL7 QRY_Q01 immediate original-mode query message, including QRD, QRF, DSC, and DSR_Q01 response handling.",
      "category": "messages",
      "route": "/messages/qry_q01",
      "sourcePath": "/content/articles/messages/qry_q01.html",
      "messageCode": "QRY_Q01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qry_r02",
      "title": "HL7 QRY_R02 (Query for Results of Observation)",
      "description": "Practical guide to the HL7 QRY_R02 query for results of observation message, including QRD, QRF, solicited observation workflows, ORF_R04 responses, and lab/radiology traps.",
      "category": "messages",
      "route": "/messages/qry_r02",
      "sourcePath": "/content/articles/messages/qry_r02.html",
      "messageCode": "QRY_R02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qry",
      "title": "HL7 QRY (Original Mode Query)",
      "description": "Practical guide to the generic HL7 QRY original-mode query message, including QRD, QRF, legacy query workflows, filters, and migration notes.",
      "category": "messages",
      "route": "/messages/qry",
      "sourcePath": "/content/articles/messages/qry.html",
      "messageCode": "QRY",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qsb_q16",
      "title": "HL7 QSB_Q16 (Create Subscription)",
      "description": "Practical guide to the HL7 QSB_Q16 create subscription query message, including QPD, RCP, DSC, subscription filters, result feeds, and cleanup behavior.",
      "category": "messages",
      "route": "/messages/qsb_q16",
      "sourcePath": "/content/articles/messages/qsb_q16.html",
      "messageCode": "QSB_Q16",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-qvr_q17",
      "title": "HL7 QVR_Q17 (Query for Previous Events)",
      "description": "Practical guide to the HL7 QVR_Q17 query for previous events message, including QPD, optional query-by-example segments, RCP, DSC, and replay-style workflows.",
      "category": "messages",
      "route": "/messages/qvr_q17",
      "sourcePath": "/content/articles/messages/qvr_q17.html",
      "messageCode": "QVR_Q17",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rar_rar",
      "title": "HL7 RAR_RAR (Pharmacy/Treatment Administration Information)",
      "description": "Practical guide to the HL7 RAR_RAR pharmacy and treatment administration information response, including QRD, QRF, ORC, RXE, RXA, RXR, RXC, and continuation handling.",
      "category": "messages",
      "route": "/messages/rar_rar",
      "sourcePath": "/content/articles/messages/rar_rar.html",
      "messageCode": "RAR_RAR",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ras_o17",
      "title": "HL7 RAS_O17 (Pharmacy/Treatment Administration)",
      "description": "Practical guide to the HL7 RAS_O17 pharmacy/treatment administration message, including RXA, RXR, ORC, medication administration, MAR workflows, and administration traps.",
      "category": "messages",
      "route": "/messages/ras_o17",
      "sourcePath": "/content/articles/messages/ras_o17.html",
      "messageCode": "RAS_O17",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rci_i05",
      "title": "HL7 RCI_I05 (Return Patient Clinical Information)",
      "description": "Practical guide to the HL7 RCI_I05 return patient clinical information message, including MSA, QRD, QRF, PID, DG1, AL1, OBR, OBX, and RQC_I05 workflows.",
      "category": "messages",
      "route": "/messages/rci_i05",
      "sourcePath": "/content/articles/messages/rci_i05.html",
      "messageCode": "RCI_I05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rcl_i06",
      "title": "HL7 RCL_I06 (Clinical Data Listing)",
      "description": "Practical guide to the HL7 RCL_I06 request/receipt of clinical data listing message, including QRD, QRF, PID, DG1, AL1, DSP, DSC, and older clinical query workflows.",
      "category": "messages",
      "route": "/messages/rcl_i06",
      "sourcePath": "/content/articles/messages/rcl_i06.html",
      "messageCode": "RCL_I06",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rde_o11",
      "title": "HL7 RDE_O11 (Pharmacy/Treatment Encoded Order)",
      "description": "Practical guide to the HL7 RDE_O11 pharmacy/treatment encoded order message, including ORC, RXO, RXE, TQ1, RXR, RXC, OBX, and medication-order workflow traps.",
      "category": "messages",
      "route": "/messages/rde_o11",
      "sourcePath": "/content/articles/messages/rde_o11.html",
      "messageCode": "RDE_O11",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rdr_rdr",
      "title": "HL7 RDR_RDR (Pharmacy/Treatment Dispense Information)",
      "description": "Practical guide to the HL7 RDR_RDR pharmacy and treatment dispense information response, including QRD, QRF, ORC, RXE, RXD, RXR, RXC, and continuation handling.",
      "category": "messages",
      "route": "/messages/rdr_rdr",
      "sourcePath": "/content/articles/messages/rdr_rdr.html",
      "messageCode": "RDR_RDR",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rds_o13",
      "title": "HL7 RDS_O13 (Pharmacy/Treatment Dispense)",
      "description": "Practical guide to the HL7 RDS_O13 pharmacy/treatment dispense message, including ORC, RXE, RXD, RXR, RXC, medication dispensing, and nursing handoff workflows.",
      "category": "messages",
      "route": "/messages/rds_o13",
      "sourcePath": "/content/articles/messages/rds_o13.html",
      "messageCode": "RDS_O13",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rdy_k15",
      "title": "HL7 RDY_K15 (Display Response)",
      "description": "Practical guide to the HL7 RDY_K15 display response message, including MSA, QAK, QPD, DSP display lines, DSC, and QBP_Q15 workflows.",
      "category": "messages",
      "route": "/messages/rdy_k15",
      "sourcePath": "/content/articles/messages/rdy_k15.html",
      "messageCode": "RDY_K15",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ref_i12",
      "title": "HL7 REF_I12 (Patient Referral)",
      "description": "Practical guide to the HL7 REF_I12 patient referral message, including RF1, AUT, PRD, CTD, PID, IN1, DG1, AL1, PR1, OBR, OBX, PV1, and RRI_I12 workflows.",
      "category": "messages",
      "route": "/messages/ref_i12",
      "sourcePath": "/content/articles/messages/ref_i12.html",
      "messageCode": "REF_I12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rer_rer",
      "title": "HL7 RER_RER (Pharmacy/Treatment Encoded Order Information)",
      "description": "Practical guide to the HL7 RER_RER pharmacy and treatment encoded order information response, including QRD, QRF, ORC, RXE, RXR, RXC, and continuation handling.",
      "category": "messages",
      "route": "/messages/rer_rer",
      "sourcePath": "/content/articles/messages/rer_rer.html",
      "messageCode": "RER_RER",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rgr_rgr",
      "title": "HL7 RGR_RGR (Pharmacy/Treatment Dose Information)",
      "description": "Practical guide to the HL7 RGR_RGR pharmacy and treatment dose information response, including QRD, QRF, ORC, RXE, RXG, RXR, RXC, and continuation handling.",
      "category": "messages",
      "route": "/messages/rgr_rgr",
      "sourcePath": "/content/articles/messages/rgr_rgr.html",
      "messageCode": "RGR_RGR",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rgv_o15",
      "title": "HL7 RGV_O15 (Pharmacy/Treatment Give)",
      "description": "Practical guide to the HL7 RGV_O15 pharmacy/treatment give message, including RXG, timing, route, components, and scheduled give workflows.",
      "category": "messages",
      "route": "/messages/rgv_o15",
      "sourcePath": "/content/articles/messages/rgv_o15.html",
      "messageCode": "RGV_O15",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ror_ror",
      "title": "HL7 ROR_ROR (Pharmacy Prescription Order Query Response)",
      "description": "Practical guide to the HL7 ROR_ROR pharmacy prescription order query response, including QRD, QRF, ORC, RXO, RXR, RXC, and continuation handling.",
      "category": "messages",
      "route": "/messages/ror_ror",
      "sourcePath": "/content/articles/messages/ror_ror.html",
      "messageCode": "ROR_ROR",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rpa_i08",
      "title": "HL7 RPA_I08 (Treatment Authorization Response)",
      "description": "Practical guide to the HL7 RPA_I08 treatment authorization response message, including MSA, RF1, AUT, PRD, PID, IN1, DG1, PR1, OBR, OBX, PV1, and RQA_I08 workflows.",
      "category": "messages",
      "route": "/messages/rpa_i08",
      "sourcePath": "/content/articles/messages/rpa_i08.html",
      "messageCode": "RPA_I08",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rpi_i01",
      "title": "HL7 RPI_I01 (Return Insurance Information)",
      "description": "Practical guide to the HL7 RPI_I01 return insurance information message, including MSA, PRD, CTD, PID, GT1, IN1, IN2, IN3, and RQI_I01 response workflows.",
      "category": "messages",
      "route": "/messages/rpi_i01",
      "sourcePath": "/content/articles/messages/rpi_i01.html",
      "messageCode": "RPI_I01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rpi_i04",
      "title": "HL7 RPI_I04 (Return Patient Demographic Data)",
      "description": "Practical guide to the HL7 RPI_I04 return patient demographic data message, including MSA, PRD, CTD, PID, NK1, GT1, IN1, IN2, IN3, and RQP_I04 workflows.",
      "category": "messages",
      "route": "/messages/rpi_i04",
      "sourcePath": "/content/articles/messages/rpi_i04.html",
      "messageCode": "RPI_I04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rpl_i02",
      "title": "HL7 RPL_I02 (Patient Selection Display List)",
      "description": "Practical guide to the HL7 RPL_I02 request/receipt of patient selection display list message, including MSA, PRD, CTD, DSP, DSC, and older patient selection workflows.",
      "category": "messages",
      "route": "/messages/rpl_i02",
      "sourcePath": "/content/articles/messages/rpl_i02.html",
      "messageCode": "RPL_I02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rpr_i03",
      "title": "HL7 RPR_I03 (Patient Selection List)",
      "description": "Practical guide to the HL7 RPR_I03 request/receipt of patient selection list message, including MSA, PRD, CTD, PID, and older patient matching workflows.",
      "category": "messages",
      "route": "/messages/rpr_i03",
      "sourcePath": "/content/articles/messages/rpr_i03.html",
      "messageCode": "RPR_I03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rqa_i08",
      "title": "HL7 RQA_I08 (Request for Treatment Authorization)",
      "description": "Practical guide to the HL7 RQA_I08 request for treatment authorization information message, including RF1, AUT, PRD, PID, IN1, DG1, PR1, OBR, OBX, PV1, and RPA_I08 workflows.",
      "category": "messages",
      "route": "/messages/rqa_i08",
      "sourcePath": "/content/articles/messages/rqa_i08.html",
      "messageCode": "RQA_I08",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rqc_i05",
      "title": "HL7 RQC_I05 (Request for Patient Clinical Information)",
      "description": "Practical guide to the HL7 RQC_I05 request for patient clinical information message, including QRD, QRF, PRD, CTD, PID, and RCI_I05 workflows.",
      "category": "messages",
      "route": "/messages/rqc_i05",
      "sourcePath": "/content/articles/messages/rqc_i05.html",
      "messageCode": "RQC_I05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rqi_i01",
      "title": "HL7 RQI_I01 (Request for Insurance Information)",
      "description": "Practical guide to the HL7 RQI_I01 request for insurance information message, including PRD, CTD, PID, GT1, IN1, IN2, IN3, and RPI_I01 response workflows.",
      "category": "messages",
      "route": "/messages/rqi_i01",
      "sourcePath": "/content/articles/messages/rqi_i01.html",
      "messageCode": "RQI_I01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rqp_i04",
      "title": "HL7 RQP_I04 (Request for Patient Demographic Data)",
      "description": "Practical guide to the HL7 RQP_I04 request for patient demographic data message, including PRD, CTD, PID, NK1, GT1, NTE, and RPI_I04 response workflows.",
      "category": "messages",
      "route": "/messages/rqp_i04",
      "sourcePath": "/content/articles/messages/rqp_i04.html",
      "messageCode": "RQP_I04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rqq_q09",
      "title": "HL7 RQQ_Q09 (Event Replay Query)",
      "description": "Practical guide to the HL7 RQQ_Q09 event replay query message, including ERQ, DSC, replay windows, duplicate control, and legacy query behavior.",
      "category": "messages",
      "route": "/messages/rqq_q09",
      "sourcePath": "/content/articles/messages/rqq_q09.html",
      "messageCode": "RQQ_Q09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rra_o18",
      "title": "HL7 RRA_O18 (Pharmacy/Treatment Administration Acknowledgment)",
      "description": "Practical guide to the HL7 RRA_O18 pharmacy/treatment administration acknowledgment message, including MSA, ERR, ORC, RXA, RXR, and medication administration response workflow traps.",
      "category": "messages",
      "route": "/messages/rra_o18",
      "sourcePath": "/content/articles/messages/rra_o18.html",
      "messageCode": "RRA_O18",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rrd_o14",
      "title": "HL7 RRD_O14 (Pharmacy/Treatment Dispense Acknowledgment)",
      "description": "Practical guide to the HL7 RRD_O14 pharmacy/treatment dispense acknowledgment message, including MSA, ERR, ORC, RXD, RXR, RXC, and dispense response workflow traps.",
      "category": "messages",
      "route": "/messages/rrd_o14",
      "sourcePath": "/content/articles/messages/rrd_o14.html",
      "messageCode": "RRD_O14",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rre_o12",
      "title": "HL7 RRE_O12 (Pharmacy/Treatment Encoded Order Acknowledgment)",
      "description": "Practical guide to the HL7 RRE_O12 pharmacy/treatment encoded order acknowledgment message, including MSA, ERR, ORC, RXE, RXR, RXC, and order response workflow traps.",
      "category": "messages",
      "route": "/messages/rre_o12",
      "sourcePath": "/content/articles/messages/rre_o12.html",
      "messageCode": "RRE_O12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rrg_o16",
      "title": "HL7 RRG_O16 (Pharmacy/Treatment Give Acknowledgment)",
      "description": "Practical guide to the HL7 RRG_O16 pharmacy/treatment give acknowledgment message, including MSA, ERR, ORC, RXG, TQ1, RXR, RXC, and give response workflow traps.",
      "category": "messages",
      "route": "/messages/rrg_o16",
      "sourcePath": "/content/articles/messages/rrg_o16.html",
      "messageCode": "RRG_O16",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rri_i12",
      "title": "HL7 RRI_I12 (Patient Referral Response)",
      "description": "Practical guide to the HL7 RRI_I12 patient referral response message, including MSA, RF1, AUT, PRD, CTD, PID, DG1, PR1, OBR, OBX, PV1, and REF_I12 workflows.",
      "category": "messages",
      "route": "/messages/rri_i12",
      "sourcePath": "/content/articles/messages/rri_i12.html",
      "messageCode": "RRI_I12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_k11",
      "title": "HL7 RSP_K11 (Segment Pattern Response)",
      "description": "Practical guide to the HL7 RSP_K11 segment-pattern response message, including MSA, QAK, QPD, RDF, RDT, errors, continuation, and QBP_Q11 workflows.",
      "category": "messages",
      "route": "/messages/rsp_k11",
      "sourcePath": "/content/articles/messages/rsp_k11.html",
      "messageCode": "RSP_K11",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_k21",
      "title": "HL7 RSP_K21 (Get Person Demographics Response)",
      "description": "Practical guide to the HL7 RSP_K21 person demographics response, including MSA, QAK, QPD, PID, PD1, NK1, QRI, demographics matching, and query traps.",
      "category": "messages",
      "route": "/messages/rsp_k21",
      "sourcePath": "/content/articles/messages/rsp_k21.html",
      "messageCode": "RSP_K21",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_k23",
      "title": "HL7 RSP_K23 (Corresponding Identifiers Response)",
      "description": "Practical guide to the HL7 RSP_K23 corresponding identifiers response, including QAK, QPD, PID-3, assigning authorities, PIX-style responses, and no-match behavior.",
      "category": "messages",
      "route": "/messages/rsp_k23",
      "sourcePath": "/content/articles/messages/rsp_k23.html",
      "messageCode": "RSP_K23",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_k25",
      "title": "HL7 RSP_K25 (Personnel Information Response)",
      "description": "Practical guide to the HL7 RSP_K25 personnel information response, including MSA, QAK, QPD, RCP, STF, PRA, ORG, AFF, LAN, EDU, CER, and staff directory workflows.",
      "category": "messages",
      "route": "/messages/rsp_k25",
      "sourcePath": "/content/articles/messages/rsp_k25.html",
      "messageCode": "RSP_K25",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_k31",
      "title": "HL7 RSP_K31 (Dispense History Response)",
      "description": "Practical guide to the HL7 RSP_K31 dispense history response message, including QAK, QPD, RCP, patient groups, pharmacy order groups, RXD, RXR, RXC, and OBX.",
      "category": "messages",
      "route": "/messages/rsp_k31",
      "sourcePath": "/content/articles/messages/rsp_k31.html",
      "messageCode": "RSP_K31",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_q11",
      "title": "HL7 RSP_Q11 (Location Segment Pattern Response)",
      "description": "Practical guide to the HL7 RSP_Q11 location-shaped segment pattern response, including MSA, QAK, QPD, MFE, LOC, LDP, LCC, and Q11 workflows.",
      "category": "messages",
      "route": "/messages/rsp_q11",
      "sourcePath": "/content/articles/messages/rsp_q11.html",
      "messageCode": "RSP_Q11",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_z82",
      "title": "HL7 RSP_Z82 (Dispense History Response)",
      "description": "Practical guide to the HL7 RSP_Z82 dispense history response message, including MSA, QAK, QPD, RCP, PID, ORC, RXD, RXR, OBX, and pharmacy history traps.",
      "category": "messages",
      "route": "/messages/rsp_z82",
      "sourcePath": "/content/articles/messages/rsp_z82.html",
      "messageCode": "RSP_Z82",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_z86",
      "title": "HL7 RSP_Z86 (Pharmacy Information Comprehensive Response)",
      "description": "Practical guide to the HL7 RSP_Z86 comprehensive pharmacy information response, including MSA, QAK, QPD, PID, ORC, RXE, RXD, RXG, RXA, RXR, RXC, and OBX.",
      "category": "messages",
      "route": "/messages/rsp_z86",
      "sourcePath": "/content/articles/messages/rsp_z86.html",
      "messageCode": "RSP_Z86",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_z88",
      "title": "HL7 RSP_Z88 (Dispense Information Response)",
      "description": "Practical guide to the HL7 RSP_Z88 dispense information response, including MSA, QAK, QPD, RCP, PID, AL1, ORC, RXO, RXE, RXD, RXR, RXC, OBX, and DSC.",
      "category": "messages",
      "route": "/messages/rsp_z88",
      "sourcePath": "/content/articles/messages/rsp_z88.html",
      "messageCode": "RSP_Z88",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rsp_z90",
      "title": "HL7 RSP_Z90 (Lab Results History Response)",
      "description": "Practical guide to the HL7 RSP_Z90 lab results history response, including MSA, QAK, QPD, RCP, PID, ORC, OBR, OBX, SPM, and continuation handling.",
      "category": "messages",
      "route": "/messages/rsp_z90",
      "sourcePath": "/content/articles/messages/rsp_z90.html",
      "messageCode": "RSP_Z90",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rtb_k13",
      "title": "HL7 RTB_K13 (Tabular Response)",
      "description": "Practical guide to the HL7 RTB_K13 tabular response message, including MSA, QAK, QPD, RDF, RDT, DSC, and QBP_Q13 workflows.",
      "category": "messages",
      "route": "/messages/rtb_k13",
      "sourcePath": "/content/articles/messages/rtb_k13.html",
      "messageCode": "RTB_K13",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rtb_knn",
      "title": "HL7 RTB_Knn (Generic Tabular Response)",
      "description": "Practical guide to the generic HL7 RTB_Knn tabular response message, including MSA, QAK, QPD, RDF, RDT, continuation, and profile-defined row content.",
      "category": "messages",
      "route": "/messages/rtb_knn",
      "sourcePath": "/content/articles/messages/rtb_knn.html",
      "messageCode": "RTB_Knn",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-rtb_z74",
      "title": "HL7 RTB_Z74 (Phone Call Tabular Response)",
      "description": "Practical guide to the HL7 RTB_Z74 tabular response message for phone-call query results, including MSA, QAK, QPD, RDF, RDT, and continuation.",
      "category": "messages",
      "route": "/messages/rtb_z74",
      "sourcePath": "/content/articles/messages/rtb_z74.html",
      "messageCode": "RTB_Z74",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-siu_s12",
      "title": "HL7 SIU_S12 (New Appointment Booking)",
      "description": "Practical guide to the HL7 SIU_S12 notification of new appointment booking message, including SCH, TQ1, PID, PV1, RGS, AIS, AIG, AIL, and AIP.",
      "category": "messages",
      "route": "/messages/siu_s12",
      "sourcePath": "/content/articles/messages/siu_s12.html",
      "messageCode": "SIU_S12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-siu_s13",
      "title": "HL7 SIU_S13 (Appointment Rescheduling)",
      "description": "Practical guide to the HL7 SIU_S13 appointment rescheduling notification, including SIU^S13^SIU_S12, SCH, patient context, resource groups, appointment identifiers, and reschedule traps.",
      "category": "messages",
      "route": "/messages/siu_s13",
      "sourcePath": "/content/articles/messages/siu_s13.html",
      "messageCode": "SIU_S13",
      "structureCode": "SIU_S12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-siu_s14",
      "title": "HL7 SIU_S14 (Appointment Modification)",
      "description": "Practical guide to the HL7 SIU_S14 appointment modification notification, including SIU^S14^SIU_S12, SCH, AIS, AIG, AIL, AIP, and modification versus reschedule traps.",
      "category": "messages",
      "route": "/messages/siu_s14",
      "sourcePath": "/content/articles/messages/siu_s14.html",
      "messageCode": "SIU_S14",
      "structureCode": "SIU_S12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-siu_s15",
      "title": "HL7 SIU_S15 (Appointment Cancellation)",
      "description": "Practical guide to the HL7 SIU_S15 appointment cancellation notification, including SIU^S15^SIU_S12, SCH, resource groups, cancellation versus deletion, and downstream workflow traps.",
      "category": "messages",
      "route": "/messages/siu_s15",
      "sourcePath": "/content/articles/messages/siu_s15.html",
      "messageCode": "SIU_S15",
      "structureCode": "SIU_S12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-siu_s17",
      "title": "HL7 SIU_S17 (Appointment Deletion)",
      "description": "Practical guide to the HL7 SIU_S17 appointment deletion notification, including SIU^S17^SIU_S12, SCH, delete versus cancel, schedule correction workflows, and common traps.",
      "category": "messages",
      "route": "/messages/siu_s17",
      "sourcePath": "/content/articles/messages/siu_s17.html",
      "messageCode": "SIU_S17",
      "structureCode": "SIU_S12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-siu_s26",
      "title": "HL7 SIU_S26 (Patient Did Not Show Up)",
      "description": "Practical guide to the HL7 SIU_S26 no-show appointment notification, including SIU^S26^SIU_S12, SCH, patient and resource groups, statistical status, and no-show workflow traps.",
      "category": "messages",
      "route": "/messages/siu_s26",
      "sourcePath": "/content/articles/messages/siu_s26.html",
      "messageCode": "SIU_S26",
      "structureCode": "SIU_S12",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-spq_q08",
      "title": "HL7 SPQ_Q08 (Stored Procedure Request)",
      "description": "Practical guide to the HL7 SPQ_Q08 stored procedure request message, including SPR, RDF, DSC, parameter contracts, and legacy query behavior.",
      "category": "messages",
      "route": "/messages/spq_q08",
      "sourcePath": "/content/articles/messages/spq_q08.html",
      "messageCode": "SPQ_Q08",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-sqm_s25",
      "title": "HL7 SQM_S25 (Schedule Query)",
      "description": "Practical guide to the HL7 SQM_S25 original-mode schedule query message, including QRD, QRF, ARQ, APR, PID, RGS, AIS, AIG, AIL, AIP, and continuation.",
      "category": "messages",
      "route": "/messages/sqm_s25",
      "sourcePath": "/content/articles/messages/sqm_s25.html",
      "messageCode": "SQM_S25",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-sqr_s25",
      "title": "HL7 SQR_S25 (Schedule Query Response)",
      "description": "Practical guide to the HL7 SQR_S25 schedule query response message, including MSA, ERR, QAK, SCH, patient context, resource groups, and continuation.",
      "category": "messages",
      "route": "/messages/sqr_s25",
      "sourcePath": "/content/articles/messages/sqr_s25.html",
      "messageCode": "SQR_S25",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-srm_s01",
      "title": "HL7 SRM_S01 (Request New Appointment Booking)",
      "description": "Practical guide to the HL7 SRM_S01 schedule request message, including ARQ, APR, PID, RGS, AIS, AIG, AIL, AIP, and the SRR response workflow.",
      "category": "messages",
      "route": "/messages/srm_s01",
      "sourcePath": "/content/articles/messages/srm_s01.html",
      "messageCode": "SRM_S01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-srr_s01",
      "title": "HL7 SRR_S01 (Schedule Request Response)",
      "description": "Practical guide to the HL7 SRR_S01 schedule request response message, including MSA, ERR, SCH, patient context, resource groups, and how it answers SRM_S01.",
      "category": "messages",
      "route": "/messages/srr_s01",
      "sourcePath": "/content/articles/messages/srr_s01.html",
      "messageCode": "SRR_S01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ssr_u04",
      "title": "HL7 SSR_U04 (Specimen Status Request)",
      "description": "Practical guide to the HL7 SSR_U04 specimen status request message, including EQU, SAC, SPM, SSU_U03 responses, and lab automation tracking.",
      "category": "messages",
      "route": "/messages/ssr_u04",
      "sourcePath": "/content/articles/messages/ssr_u04.html",
      "messageCode": "SSR_U04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-ssu_u03",
      "title": "HL7 SSU_U03 (Specimen Status Update)",
      "description": "Practical guide to the HL7 SSU_U03 specimen status update message, including EQU, SAC, SPM, OBX, specimen container status, and lab automation tracking.",
      "category": "messages",
      "route": "/messages/ssu_u03",
      "sourcePath": "/content/articles/messages/ssu_u03.html",
      "messageCode": "SSU_U03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-sur_p09",
      "title": "HL7 SUR_P09 (Summary Product Experience Report)",
      "description": "Practical guide to the HL7 SUR_P09 summary product experience report, including FAC, PSH, PDC, NTE, product safety summaries, and regulatory reporting cautions.",
      "category": "messages",
      "route": "/messages/sur_p09",
      "sourcePath": "/content/articles/messages/sur_p09.html",
      "messageCode": "SUR_P09",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-tbr_r08",
      "title": "HL7 TBR_R08 (Tabular Data Response)",
      "description": "Practical guide to the HL7 TBR_R08 tabular data response message, including MSA, QAK, RDF, RDT, DSC, legacy query rows, and backward compatibility.",
      "category": "messages",
      "route": "/messages/tbr_r08",
      "sourcePath": "/content/articles/messages/tbr_r08.html",
      "messageCode": "TBR_R08",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-tcu_u10",
      "title": "HL7 TCU_U10 (Automated Equipment Test Code Settings Update)",
      "description": "Practical guide to the HL7 TCU_U10 automated equipment test code settings update message, including EQU, SPM, TCC, test configuration snapshots, and analyzer parameters.",
      "category": "messages",
      "route": "/messages/tcu_u10",
      "sourcePath": "/content/articles/messages/tcu_u10.html",
      "messageCode": "TCU_U10",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-udm_q05",
      "title": "HL7 UDM_Q05 (Unsolicited Display Update)",
      "description": "Practical guide to the HL7 UDM_Q05 unsolicited display update message, including URD, URS, DSP, DSC, display-line updates, and legacy query behavior.",
      "category": "messages",
      "route": "/messages/udm_q05",
      "sourcePath": "/content/articles/messages/udm_q05.html",
      "messageCode": "UDM_Q05",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-vqq_q07",
      "title": "HL7 VQQ_Q07 (Virtual Table Query)",
      "description": "Practical guide to the HL7 VQQ_Q07 virtual table query message, including VTQ, RDF, DSC, legacy table queries, and tabular response handling.",
      "category": "messages",
      "route": "/messages/vqq_q07",
      "sourcePath": "/content/articles/messages/vqq_q07.html",
      "messageCode": "VQQ_Q07",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-vxq_v01",
      "title": "HL7 VXQ_V01 (Query for Vaccination Record)",
      "description": "Practical guide to the HL7 VXQ_V01 query for vaccination record message, including QRD, QRF, patient matching, immunization query workflows, and migration cautions.",
      "category": "messages",
      "route": "/messages/vxq_v01",
      "sourcePath": "/content/articles/messages/vxq_v01.html",
      "messageCode": "VXQ_V01",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-vxr_v03",
      "title": "HL7 VXR_V03 (Vaccination Record Response)",
      "description": "Practical guide to the HL7 VXR_V03 vaccination record response message, including MSA, QRD, QRF, PID, ORC, RXA, RXR, OBX, and immunization response handling.",
      "category": "messages",
      "route": "/messages/vxr_v03",
      "sourcePath": "/content/articles/messages/vxr_v03.html",
      "messageCode": "VXR_V03",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-vxu_v04",
      "title": "HL7 VXU_V04 (Unsolicited Vaccination Record Update)",
      "description": "Practical guide to the HL7 VXU_V04 unsolicited vaccination record update message, including PID, PD1, ORC, RXA, RXR, OBX, IIS workflows, and ACK handling.",
      "category": "messages",
      "route": "/messages/vxu_v04",
      "sourcePath": "/content/articles/messages/vxu_v04.html",
      "messageCode": "VXU_V04",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "message-vxx_v02",
      "title": "HL7 VXX_V02 (Vaccination Query Multiple Matches Response)",
      "description": "Practical guide to the HL7 VXX_V02 response to vaccination query returning multiple PID matches, including MSA, QRD, QRF, PID, NK1, and legacy immunization query matching.",
      "category": "messages",
      "route": "/messages/vxx_v02",
      "sourcePath": "/content/articles/messages/vxx_v02.html",
      "messageCode": "VXX_V02",
      "structurePanelDefaultOpen": true
    },
    {
      "id": "datatype-ad",
      "title": "HL7 AD (Address)",
      "description": "The HL7 AD datatype carries address values. This practical quick lookup explains where AD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ad",
      "sourcePath": "/content/articles/datatypes/ad.html",
      "datatypeCode": "AD"
    },
    {
      "id": "datatype-aui",
      "title": "HL7 AUI (Authorization Information)",
      "description": "The HL7 AUI datatype carries authorization information values. This practical quick lookup explains where AUI appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/aui",
      "sourcePath": "/content/articles/datatypes/aui.html",
      "datatypeCode": "AUI"
    },
    {
      "id": "datatype-ccd",
      "title": "HL7 CCD (Charge Code and Date)",
      "description": "The HL7 CCD datatype carries charge code and date values. This practical quick lookup explains where CCD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ccd",
      "sourcePath": "/content/articles/datatypes/ccd.html",
      "datatypeCode": "CCD"
    },
    {
      "id": "datatype-ccp",
      "title": "HL7 CCP (Channel Calibration Parameters)",
      "description": "The HL7 CCP datatype carries channel calibration parameters values. This practical quick lookup explains where CCP appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ccp",
      "sourcePath": "/content/articles/datatypes/ccp.html",
      "datatypeCode": "CCP"
    },
    {
      "id": "datatype-cd",
      "title": "HL7 CD (Channel Definition)",
      "description": "The HL7 CD datatype carries channel definition values. This practical quick lookup explains where CD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/cd",
      "sourcePath": "/content/articles/datatypes/cd.html",
      "datatypeCode": "CD"
    },
    {
      "id": "datatype-ce",
      "title": "HL7 CE (Coded Element)",
      "description": "The HL7 CE datatype carries a coded value with text, coding system, and an alternate code. Here I explain each CE component and common coded-value traps in HL7 v2 interfaces.",
      "category": "datatypes",
      "route": "/datatypes/ce",
      "sourcePath": "/content/articles/datatypes/ce.html",
      "datatypeCode": "CE"
    },
    {
      "id": "datatype-cf",
      "title": "HL7 CF (Coded Element with Formatted Values)",
      "description": "The HL7 CF datatype carries coded element with formatted values values. This practical quick lookup explains where CF appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/cf",
      "sourcePath": "/content/articles/datatypes/cf.html",
      "datatypeCode": "CF"
    },
    {
      "id": "datatype-cne",
      "title": "HL7 CNE (Coded with No Exceptions)",
      "description": "The HL7 CNE datatype carries coded with no exceptions values. This practical quick lookup explains where CNE appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/cne",
      "sourcePath": "/content/articles/datatypes/cne.html",
      "datatypeCode": "CNE"
    },
    {
      "id": "datatype-cnn",
      "title": "HL7 CNN (Composite ID and Name Simplified)",
      "description": "The HL7 CNN datatype carries composite id and name simplified values. This practical quick lookup explains where CNN appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/cnn",
      "sourcePath": "/content/articles/datatypes/cnn.html",
      "datatypeCode": "CNN"
    },
    {
      "id": "datatype-cp",
      "title": "HL7 CP (Composite Price)",
      "description": "The HL7 CP datatype carries composite price values. This practical quick lookup explains where CP appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/cp",
      "sourcePath": "/content/articles/datatypes/cp.html",
      "datatypeCode": "CP"
    },
    {
      "id": "datatype-cq",
      "title": "HL7 CQ (Composite Quantity with Units)",
      "description": "The HL7 CQ datatype carries composite quantity with units values. This practical quick lookup explains where CQ appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/cq",
      "sourcePath": "/content/articles/datatypes/cq.html",
      "datatypeCode": "CQ"
    },
    {
      "id": "datatype-csu",
      "title": "HL7 CSU (Channel Sensitivity)",
      "description": "The HL7 CSU datatype carries channel sensitivity values. This practical quick lookup explains where CSU appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/csu",
      "sourcePath": "/content/articles/datatypes/csu.html",
      "datatypeCode": "CSU"
    },
    {
      "id": "datatype-cwe",
      "title": "HL7 CWE (Coded with Exceptions)",
      "description": "The HL7 CWE datatype carries coded values with text, coding system, alternate coding, version IDs, and original text. Here I explain each CWE component and practical coding traps.",
      "category": "datatypes",
      "route": "/datatypes/cwe",
      "sourcePath": "/content/articles/datatypes/cwe.html",
      "datatypeCode": "CWE"
    },
    {
      "id": "datatype-cx",
      "title": "HL7 CX (Extended Composite ID with Check Digit)",
      "description": "The HL7 CX datatype carries an identifier with assigning authority, identifier type, check digit, dates, jurisdiction, and agency detail. Here I explain each CX component from practical interface work.",
      "category": "datatypes",
      "route": "/datatypes/cx",
      "sourcePath": "/content/articles/datatypes/cx.html",
      "datatypeCode": "CX"
    },
    {
      "id": "datatype-ddi",
      "title": "HL7 DDI (Daily Deductible Information)",
      "description": "The HL7 DDI datatype carries daily deductible information values. This practical quick lookup explains where DDI appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ddi",
      "sourcePath": "/content/articles/datatypes/ddi.html",
      "datatypeCode": "DDI"
    },
    {
      "id": "datatype-din",
      "title": "HL7 DIN (Date and Institution Name)",
      "description": "The HL7 DIN datatype carries date and institution name values. This practical quick lookup explains where DIN appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/din",
      "sourcePath": "/content/articles/datatypes/din.html",
      "datatypeCode": "DIN"
    },
    {
      "id": "datatype-dld",
      "title": "HL7 DLD (Discharge Location and Date)",
      "description": "The HL7 DLD datatype carries discharge location and date values. This practical quick lookup explains where DLD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/dld",
      "sourcePath": "/content/articles/datatypes/dld.html",
      "datatypeCode": "DLD"
    },
    {
      "id": "datatype-dln",
      "title": "HL7 DLN (Driver's License Number)",
      "description": "The HL7 DLN datatype carries driver's license number values. This practical quick lookup explains where DLN appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/dln",
      "sourcePath": "/content/articles/datatypes/dln.html",
      "datatypeCode": "DLN"
    },
    {
      "id": "datatype-dlt",
      "title": "HL7 DLT (Delta)",
      "description": "The HL7 DLT datatype carries delta values. This practical quick lookup explains where DLT appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/dlt",
      "sourcePath": "/content/articles/datatypes/dlt.html",
      "datatypeCode": "DLT"
    },
    {
      "id": "datatype-dr",
      "title": "HL7 DR (Date/Time Range)",
      "description": "The HL7 DR datatype carries date/time range values. This practical quick lookup explains where DR appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/dr",
      "sourcePath": "/content/articles/datatypes/dr.html",
      "datatypeCode": "DR"
    },
    {
      "id": "datatype-dt",
      "title": "HL7 DT (Date)",
      "description": "The HL7 DT datatype carries date values. This practical quick lookup explains where DT appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/dt",
      "sourcePath": "/content/articles/datatypes/dt.html",
      "datatypeCode": "DT"
    },
    {
      "id": "datatype-dtm",
      "title": "HL7 DTM (Date/Time)",
      "description": "The HL7 DTM datatype carries date/time values. This practical quick lookup explains where DTM appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/dtm",
      "sourcePath": "/content/articles/datatypes/dtm.html",
      "datatypeCode": "DTM"
    },
    {
      "id": "datatype-dtn",
      "title": "HL7 DTN (Day Type and Number)",
      "description": "The HL7 DTN datatype carries day type and number values. This practical quick lookup explains where DTN appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/dtn",
      "sourcePath": "/content/articles/datatypes/dtn.html",
      "datatypeCode": "DTN"
    },
    {
      "id": "datatype-ed",
      "title": "HL7 ED (Encapsulated Data)",
      "description": "The HL7 ED datatype carries encapsulated data values. This practical quick lookup explains where ED appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ed",
      "sourcePath": "/content/articles/datatypes/ed.html",
      "datatypeCode": "ED"
    },
    {
      "id": "datatype-ei",
      "title": "HL7 EI (Entity Identifier)",
      "description": "The HL7 EI datatype carries an entity identifier plus the assigning authority that owns it. Here I explain each EI component and the identifier traps that break HL7 v2 workflows.",
      "category": "datatypes",
      "route": "/datatypes/ei",
      "sourcePath": "/content/articles/datatypes/ei.html",
      "datatypeCode": "EI"
    },
    {
      "id": "datatype-eip",
      "title": "HL7 EIP (Entity Identifier Pair)",
      "description": "The HL7 EIP datatype carries entity identifier pair values. This practical quick lookup explains where EIP appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/eip",
      "sourcePath": "/content/articles/datatypes/eip.html",
      "datatypeCode": "EIP"
    },
    {
      "id": "datatype-eld",
      "title": "HL7 ELD (Error Location and Description)",
      "description": "The HL7 ELD datatype carries error location and description values. This practical quick lookup explains where ELD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/eld",
      "sourcePath": "/content/articles/datatypes/eld.html",
      "datatypeCode": "ELD"
    },
    {
      "id": "datatype-erl",
      "title": "HL7 ERL (Error Location)",
      "description": "The HL7 ERL datatype carries error location values. This practical quick lookup explains where ERL appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/erl",
      "sourcePath": "/content/articles/datatypes/erl.html",
      "datatypeCode": "ERL"
    },
    {
      "id": "datatype-fc",
      "title": "HL7 FC (Financial Class)",
      "description": "The HL7 FC datatype carries financial class values. This practical quick lookup explains where FC appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/fc",
      "sourcePath": "/content/articles/datatypes/fc.html",
      "datatypeCode": "FC"
    },
    {
      "id": "datatype-fn",
      "title": "HL7 FN (Family Name)",
      "description": "The HL7 FN datatype carries family name values. This practical quick lookup explains where FN appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/fn",
      "sourcePath": "/content/articles/datatypes/fn.html",
      "datatypeCode": "FN"
    },
    {
      "id": "datatype-ft",
      "title": "HL7 FT (Formatted Text Data)",
      "description": "The HL7 FT datatype carries formatted text data values. This practical quick lookup explains where FT appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ft",
      "sourcePath": "/content/articles/datatypes/ft.html",
      "datatypeCode": "FT"
    },
    {
      "id": "datatype-gts",
      "title": "HL7 GTS (General Timing Specification)",
      "description": "The HL7 GTS datatype carries general timing specification values. This practical quick lookup explains where GTS appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/gts",
      "sourcePath": "/content/articles/datatypes/gts.html",
      "datatypeCode": "GTS"
    },
    {
      "id": "datatype-hd",
      "title": "HL7 HD (Hierarchic Designator)",
      "description": "The HL7 HD datatype carries a namespace ID, universal ID, and universal ID type for assigning authorities, facilities, and applications. Here I explain each HD component and common identifier authority traps.",
      "category": "datatypes",
      "route": "/datatypes/hd",
      "sourcePath": "/content/articles/datatypes/hd.html",
      "datatypeCode": "HD"
    },
    {
      "id": "datatype-icd",
      "title": "HL7 ICD (Insurance Certification Definition)",
      "description": "The HL7 ICD datatype carries insurance certification definition values. This practical quick lookup explains where ICD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/icd",
      "sourcePath": "/content/articles/datatypes/icd.html",
      "datatypeCode": "ICD"
    },
    {
      "id": "datatype-id",
      "title": "HL7 ID (Coded values for HL7 tables)",
      "description": "The HL7 ID datatype carries coded values for hl7 tables values. This practical quick lookup explains where ID appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/id",
      "sourcePath": "/content/articles/datatypes/id.html",
      "datatypeCode": "ID"
    },
    {
      "id": "datatype-is",
      "title": "HL7 IS (Coded value for user-defined tables)",
      "description": "The HL7 IS datatype carries coded value for user-defined tables values. This practical quick lookup explains where IS appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/is",
      "sourcePath": "/content/articles/datatypes/is.html",
      "datatypeCode": "IS"
    },
    {
      "id": "datatype-jcc",
      "title": "HL7 JCC (Job Code/Class)",
      "description": "The HL7 JCC datatype carries job code/class values. This practical quick lookup explains where JCC appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/jcc",
      "sourcePath": "/content/articles/datatypes/jcc.html",
      "datatypeCode": "JCC"
    },
    {
      "id": "datatype-la1",
      "title": "HL7 LA1 (Location with Address Variation 1)",
      "description": "The HL7 LA1 datatype carries location with address variation 1 values. This practical quick lookup explains where LA1 appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/la1",
      "sourcePath": "/content/articles/datatypes/la1.html",
      "datatypeCode": "LA1"
    },
    {
      "id": "datatype-la2",
      "title": "HL7 LA2 (Location with Address Variation 2)",
      "description": "The HL7 LA2 datatype carries location with address variation 2 values. This practical quick lookup explains where LA2 appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/la2",
      "sourcePath": "/content/articles/datatypes/la2.html",
      "datatypeCode": "LA2"
    },
    {
      "id": "datatype-ma",
      "title": "HL7 MA (Multiplexed Array)",
      "description": "The HL7 MA datatype carries multiplexed array values. This practical quick lookup explains where MA appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ma",
      "sourcePath": "/content/articles/datatypes/ma.html",
      "datatypeCode": "MA"
    },
    {
      "id": "datatype-mo",
      "title": "HL7 MO (Money)",
      "description": "The HL7 MO datatype carries money values. This practical quick lookup explains where MO appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/mo",
      "sourcePath": "/content/articles/datatypes/mo.html",
      "datatypeCode": "MO"
    },
    {
      "id": "datatype-moc",
      "title": "HL7 MOC (Money and Code)",
      "description": "The HL7 MOC datatype carries money and code values. This practical quick lookup explains where MOC appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/moc",
      "sourcePath": "/content/articles/datatypes/moc.html",
      "datatypeCode": "MOC"
    },
    {
      "id": "datatype-mop",
      "title": "HL7 MOP (Money or Percentage)",
      "description": "The HL7 MOP datatype carries money or percentage values. This practical quick lookup explains where MOP appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/mop",
      "sourcePath": "/content/articles/datatypes/mop.html",
      "datatypeCode": "MOP"
    },
    {
      "id": "datatype-msg",
      "title": "HL7 MSG (Message Type)",
      "description": "The HL7 MSG datatype carries message type values. This practical quick lookup explains where MSG appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/msg",
      "sourcePath": "/content/articles/datatypes/msg.html",
      "datatypeCode": "MSG"
    },
    {
      "id": "datatype-na",
      "title": "HL7 NA (Numeric Array)",
      "description": "The HL7 NA datatype carries numeric array values. This practical quick lookup explains where NA appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/na",
      "sourcePath": "/content/articles/datatypes/na.html",
      "datatypeCode": "NA"
    },
    {
      "id": "datatype-ndl",
      "title": "HL7 NDL (Name with Date and Location)",
      "description": "The HL7 NDL datatype carries name with date and location values. This practical quick lookup explains where NDL appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ndl",
      "sourcePath": "/content/articles/datatypes/ndl.html",
      "datatypeCode": "NDL"
    },
    {
      "id": "datatype-nm",
      "title": "HL7 NM (Numeric)",
      "description": "The HL7 NM datatype carries numeric values. This practical quick lookup explains where NM appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/nm",
      "sourcePath": "/content/articles/datatypes/nm.html",
      "datatypeCode": "NM"
    },
    {
      "id": "datatype-nr",
      "title": "HL7 NR (Numeric Range)",
      "description": "The HL7 NR datatype carries numeric range values. This practical quick lookup explains where NR appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/nr",
      "sourcePath": "/content/articles/datatypes/nr.html",
      "datatypeCode": "NR"
    },
    {
      "id": "datatype-nul-datatype",
      "title": "HL7 NUL (HL7 NUL data type)",
      "description": "The HL7 NUL datatype carries hl7 nul data type values. This practical quick lookup explains where NUL appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/nul-datatype",
      "sourcePath": "/content/articles/datatypes/nul-datatype.html",
      "datatypeCode": "NUL"
    },
    {
      "id": "datatype-ocd",
      "title": "HL7 OCD (Occurrence Code and Date)",
      "description": "The HL7 OCD datatype carries occurrence code and date values. This practical quick lookup explains where OCD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ocd",
      "sourcePath": "/content/articles/datatypes/ocd.html",
      "datatypeCode": "OCD"
    },
    {
      "id": "datatype-osd",
      "title": "HL7 OSD (Order Sequence Definition)",
      "description": "The HL7 OSD datatype carries order sequence definition values. This practical quick lookup explains where OSD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/osd",
      "sourcePath": "/content/articles/datatypes/osd.html",
      "datatypeCode": "OSD"
    },
    {
      "id": "datatype-osp",
      "title": "HL7 OSP (Occurrence Span Code and Date)",
      "description": "The HL7 OSP datatype carries occurrence span code and date values. This practical quick lookup explains where OSP appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/osp",
      "sourcePath": "/content/articles/datatypes/osp.html",
      "datatypeCode": "OSP"
    },
    {
      "id": "datatype-pip",
      "title": "HL7 PIP (Practitioner Institutional Privileges)",
      "description": "The HL7 PIP datatype carries practitioner institutional privileges values. This practical quick lookup explains where PIP appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/pip",
      "sourcePath": "/content/articles/datatypes/pip.html",
      "datatypeCode": "PIP"
    },
    {
      "id": "datatype-pl",
      "title": "HL7 PL (Person Location)",
      "description": "The HL7 PL datatype carries patient or person location as structured facility, unit, room, bed, status, type, and location identifiers. Here I explain each PL component and common HL7 location traps.",
      "category": "datatypes",
      "route": "/datatypes/pl",
      "sourcePath": "/content/articles/datatypes/pl.html",
      "datatypeCode": "PL"
    },
    {
      "id": "datatype-pln",
      "title": "HL7 PLN (Practitioner License ID Number)",
      "description": "The HL7 PLN datatype carries practitioner license id number values. This practical quick lookup explains where PLN appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/pln",
      "sourcePath": "/content/articles/datatypes/pln.html",
      "datatypeCode": "PLN"
    },
    {
      "id": "datatype-ppn",
      "title": "HL7 PPN (Performing Person Time Stamp)",
      "description": "The HL7 PPN datatype carries performing person time stamp values. This practical quick lookup explains where PPN appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ppn",
      "sourcePath": "/content/articles/datatypes/ppn.html",
      "datatypeCode": "PPN"
    },
    {
      "id": "datatype-prl",
      "title": "HL7 PRL (Parent Result Link)",
      "description": "The HL7 PRL datatype carries parent result link values. This practical quick lookup explains where PRL appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/prl",
      "sourcePath": "/content/articles/datatypes/prl.html",
      "datatypeCode": "PRL"
    },
    {
      "id": "datatype-pt",
      "title": "HL7 PT (Processing Type)",
      "description": "The HL7 PT datatype carries processing type values. This practical quick lookup explains where PT appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/pt",
      "sourcePath": "/content/articles/datatypes/pt.html",
      "datatypeCode": "PT"
    },
    {
      "id": "datatype-pta",
      "title": "HL7 PTA (Policy Type and Amount)",
      "description": "The HL7 PTA datatype carries policy type and amount values. This practical quick lookup explains where PTA appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/pta",
      "sourcePath": "/content/articles/datatypes/pta.html",
      "datatypeCode": "PTA"
    },
    {
      "id": "datatype-qip",
      "title": "HL7 QIP (Query Input Parameter List)",
      "description": "The HL7 QIP datatype carries query input parameter list values. This practical quick lookup explains where QIP appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/qip",
      "sourcePath": "/content/articles/datatypes/qip.html",
      "datatypeCode": "QIP"
    },
    {
      "id": "datatype-qsc",
      "title": "HL7 QSC (Query Selection Criteria)",
      "description": "The HL7 QSC datatype carries query selection criteria values. This practical quick lookup explains where QSC appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/qsc",
      "sourcePath": "/content/articles/datatypes/qsc.html",
      "datatypeCode": "QSC"
    },
    {
      "id": "datatype-rcd",
      "title": "HL7 RCD (Row Column Definition)",
      "description": "The HL7 RCD datatype carries row column definition values. This practical quick lookup explains where RCD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/rcd",
      "sourcePath": "/content/articles/datatypes/rcd.html",
      "datatypeCode": "RCD"
    },
    {
      "id": "datatype-rfr",
      "title": "HL7 RFR (Reference Range)",
      "description": "The HL7 RFR datatype carries reference range values. This practical quick lookup explains where RFR appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/rfr",
      "sourcePath": "/content/articles/datatypes/rfr.html",
      "datatypeCode": "RFR"
    },
    {
      "id": "datatype-ri",
      "title": "HL7 RI (Repeat Interval)",
      "description": "The HL7 RI datatype carries repeat interval values. This practical quick lookup explains where RI appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ri",
      "sourcePath": "/content/articles/datatypes/ri.html",
      "datatypeCode": "RI"
    },
    {
      "id": "datatype-rmc",
      "title": "HL7 RMC (Room Coverage)",
      "description": "The HL7 RMC datatype carries room coverage values. This practical quick lookup explains where RMC appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/rmc",
      "sourcePath": "/content/articles/datatypes/rmc.html",
      "datatypeCode": "RMC"
    },
    {
      "id": "datatype-rp",
      "title": "HL7 RP (Reference Pointer)",
      "description": "The HL7 RP datatype carries reference pointer values. This practical quick lookup explains where RP appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/rp",
      "sourcePath": "/content/articles/datatypes/rp.html",
      "datatypeCode": "RP"
    },
    {
      "id": "datatype-rpt",
      "title": "HL7 RPT (Repeat Pattern)",
      "description": "The HL7 RPT datatype carries repeat pattern values. This practical quick lookup explains where RPT appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/rpt",
      "sourcePath": "/content/articles/datatypes/rpt.html",
      "datatypeCode": "RPT"
    },
    {
      "id": "datatype-sad",
      "title": "HL7 SAD (Street Address)",
      "description": "The HL7 SAD datatype carries street address values. This practical quick lookup explains where SAD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/sad",
      "sourcePath": "/content/articles/datatypes/sad.html",
      "datatypeCode": "SAD"
    },
    {
      "id": "datatype-scv",
      "title": "HL7 SCV (Scheduling Class Value Pair)",
      "description": "The HL7 SCV datatype carries scheduling class value pair values. This practical quick lookup explains where SCV appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/scv",
      "sourcePath": "/content/articles/datatypes/scv.html",
      "datatypeCode": "SCV"
    },
    {
      "id": "datatype-si",
      "title": "HL7 SI (Sequence ID)",
      "description": "The HL7 SI datatype carries sequence id values. This practical quick lookup explains where SI appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/si",
      "sourcePath": "/content/articles/datatypes/si.html",
      "datatypeCode": "SI"
    },
    {
      "id": "datatype-sn",
      "title": "HL7 SN (Structured Numeric)",
      "description": "The HL7 SN datatype carries structured numeric values. This practical quick lookup explains where SN appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/sn",
      "sourcePath": "/content/articles/datatypes/sn.html",
      "datatypeCode": "SN"
    },
    {
      "id": "datatype-spd",
      "title": "HL7 SPD (Specialty Description)",
      "description": "The HL7 SPD datatype carries specialty description values. This practical quick lookup explains where SPD appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/spd",
      "sourcePath": "/content/articles/datatypes/spd.html",
      "datatypeCode": "SPD"
    },
    {
      "id": "datatype-sps",
      "title": "HL7 SPS (Specimen Source)",
      "description": "The HL7 SPS datatype carries specimen source values. This practical quick lookup explains where SPS appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/sps",
      "sourcePath": "/content/articles/datatypes/sps.html",
      "datatypeCode": "SPS"
    },
    {
      "id": "datatype-srt",
      "title": "HL7 SRT (Sort Order)",
      "description": "The HL7 SRT datatype carries sort order values. This practical quick lookup explains where SRT appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/srt",
      "sourcePath": "/content/articles/datatypes/srt.html",
      "datatypeCode": "SRT"
    },
    {
      "id": "datatype-st",
      "title": "HL7 ST (String Data)",
      "description": "The HL7 ST datatype carries string data values. This practical quick lookup explains where ST appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/st",
      "sourcePath": "/content/articles/datatypes/st.html",
      "datatypeCode": "ST"
    },
    {
      "id": "datatype-tm",
      "title": "HL7 TM (Time)",
      "description": "The HL7 TM datatype carries time values. This practical quick lookup explains where TM appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/tm",
      "sourcePath": "/content/articles/datatypes/tm.html",
      "datatypeCode": "TM"
    },
    {
      "id": "datatype-tq",
      "title": "HL7 TQ (Timing Quantity)",
      "description": "The HL7 TQ datatype carries timing quantity values. This practical quick lookup explains where TQ appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/tq",
      "sourcePath": "/content/articles/datatypes/tq.html",
      "datatypeCode": "TQ"
    },
    {
      "id": "datatype-ts",
      "title": "HL7 TS (Time Stamp)",
      "description": "The HL7 TS datatype carries time stamp values. This practical quick lookup explains where TS appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/ts",
      "sourcePath": "/content/articles/datatypes/ts.html",
      "datatypeCode": "TS"
    },
    {
      "id": "datatype-tx",
      "title": "HL7 TX (Text Data)",
      "description": "The HL7 TX datatype carries text data values. This practical quick lookup explains where TX appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/tx",
      "sourcePath": "/content/articles/datatypes/tx.html",
      "datatypeCode": "TX"
    },
    {
      "id": "datatype-uvc",
      "title": "HL7 UVC (UB Value Code and Amount)",
      "description": "The HL7 UVC datatype carries ub value code and amount values. This practical quick lookup explains where UVC appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/uvc",
      "sourcePath": "/content/articles/datatypes/uvc.html",
      "datatypeCode": "UVC"
    },
    {
      "id": "datatype-var",
      "title": "HL7 var (Variable Datatype)",
      "description": "The HL7 var datatype carries variable datatype values. This practical quick lookup explains where var appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/var",
      "sourcePath": "/content/articles/datatypes/var.html",
      "datatypeCode": "var"
    },
    {
      "id": "datatype-varies",
      "title": "HL7 varies (Variable Datatype)",
      "description": "The HL7 varies datatype carries variable datatype values. This practical quick lookup explains where varies appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/varies",
      "sourcePath": "/content/articles/datatypes/varies.html",
      "datatypeCode": "varies"
    },
    {
      "id": "datatype-vh",
      "title": "HL7 VH (Visiting Hours)",
      "description": "The HL7 VH datatype carries visiting hours values. This practical quick lookup explains where VH appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/vh",
      "sourcePath": "/content/articles/datatypes/vh.html",
      "datatypeCode": "VH"
    },
    {
      "id": "datatype-vid",
      "title": "HL7 VID (Version Identifier)",
      "description": "The HL7 VID datatype carries version identifier values. This practical quick lookup explains where VID appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/vid",
      "sourcePath": "/content/articles/datatypes/vid.html",
      "datatypeCode": "VID"
    },
    {
      "id": "datatype-vr",
      "title": "HL7 VR (Value Range)",
      "description": "The HL7 VR datatype carries value range values. This practical quick lookup explains where VR appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/vr",
      "sourcePath": "/content/articles/datatypes/vr.html",
      "datatypeCode": "VR"
    },
    {
      "id": "datatype-wvi",
      "title": "HL7 WVI (Channel Identifier)",
      "description": "The HL7 WVI datatype carries channel identifier values. This practical quick lookup explains where WVI appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/wvi",
      "sourcePath": "/content/articles/datatypes/wvi.html",
      "datatypeCode": "WVI"
    },
    {
      "id": "datatype-wvs",
      "title": "HL7 WVS (Waveform Source)",
      "description": "The HL7 WVS datatype carries waveform source values. This practical quick lookup explains where WVS appears and how to read its HL7 v2.5.1 components.",
      "category": "datatypes",
      "route": "/datatypes/wvs",
      "sourcePath": "/content/articles/datatypes/wvs.html",
      "datatypeCode": "WVS"
    },
    {
      "id": "datatype-xad",
      "title": "HL7 XAD (Extended Address)",
      "description": "The HL7 XAD datatype carries structured addresses for patients, contacts, guarantors, organizations, and facilities. Here I explain each XAD component and common address mapping traps.",
      "category": "datatypes",
      "route": "/datatypes/xad",
      "sourcePath": "/content/articles/datatypes/xad.html",
      "datatypeCode": "XAD"
    },
    {
      "id": "datatype-xcn",
      "title": "HL7 XCN (Extended ID and Name for Persons)",
      "description": "The HL7 XCN datatype carries a person's identifier and name together. Here I explain each XCN component, common provider ID patterns, assigning authority, identifier type code, and practical use across HL7 interfaces.",
      "category": "datatypes",
      "route": "/datatypes/xcn",
      "sourcePath": "/content/articles/datatypes/xcn.html",
      "datatypeCode": "XCN"
    },
    {
      "id": "datatype-xon",
      "title": "HL7 XON (Extended Organization Name and ID)",
      "description": "The HL7 XON datatype carries an organization name plus organization identifiers, assigning authority, identifier type, facility, and name representation. Here I explain each XON component and common organization identity traps.",
      "category": "datatypes",
      "route": "/datatypes/xon",
      "sourcePath": "/content/articles/datatypes/xon.html",
      "datatypeCode": "XON"
    },
    {
      "id": "datatype-xpn",
      "title": "HL7 XPN (Extended Person Name)",
      "description": "The HL7 XPN datatype carries a person's name as structured components. Here I explain XPN family, given, suffix, prefix, name type, representation, validity, and common implementation traps.",
      "category": "datatypes",
      "route": "/datatypes/xpn",
      "sourcePath": "/content/articles/datatypes/xpn.html",
      "datatypeCode": "XPN"
    },
    {
      "id": "datatype-xtn",
      "title": "HL7 XTN (Extended Telecommunication Number)",
      "description": "The HL7 XTN datatype carries phone, mobile, fax, email, extension, and unformatted contact details. Here I explain each XTN component and common telecom mapping traps.",
      "category": "datatypes",
      "route": "/datatypes/xtn",
      "sourcePath": "/content/articles/datatypes/xtn.html",
      "datatypeCode": "XTN"
    }
  ]
}
